/* マイラーズ選手名鑑
 * ページにはデータを持たない。Googleでログイン → データ側(Apps Script)が名簿と照合 → 通った人にだけデータが届く。
 */
(function () {
  'use strict';

  const CLIENT_ID = '987500209742-cp6mepp6rgr5uoosg60g3dnqkubf7a4b.apps.googleusercontent.com';
  const API = 'https://script.google.com/macros/s/AKfycbyeCeGoHhlEKKs_hGIPQc_Yow-vzDt7WZl-hf_dN2gi07M-R1BmQgBKZ8U5Q1tTPq9H/exec';
  const TOKEN_KEY = 'mz_token';
  // レース資料庫（別のデータ側）。同じGoogleログインで読める。報告書・計画書をカードの戦績に結び付ける
  const LIB_API = 'https://script.google.com/macros/s/AKfycbzbO-CV1U_1BN_9TWxGIh4oKKgK3pENRyRG77eAwnubcUFKVMQuySCaPq-FaTZFWfIs/exec';
  const LIB_URL = 'https://go-trail.net/pages/milers-library';

  // ---- 新しいデータ側（Supabase）への切り替え（2026-10-21〜・試験中）----
  // 切り替え後：既定は新しいデータ側。?db=old を付けて開いた端末だけ前の仕組みに戻す（非常用・?db=new で解除）
  const SB_URL = 'https://jbeubnuoinmkjjldthxb.supabase.co', SB_KEY = 'sb_publishable_TBuE0XBK4Qj1LIKksdCcRQ_argRbXuk'; // 本番
  const SB_FN = SB_URL + '/functions/v1/api', SB_SES = 'milersSb';
  const DB_NEW = (() => { try { const q = new URLSearchParams(location.search).get('db'); if (q === 'old') localStorage.setItem('milersDb', 'old'); if (q === 'new') localStorage.removeItem('milersDb'); return localStorage.getItem('milersDb') !== 'old'; } catch (e) { return false; } })();
  function sbLoad() { try { return JSON.parse(sessionStorage.getItem(SB_SES) || 'null'); } catch (e) { return null; } }
  function sbSave(s) { try { if (s) sessionStorage.setItem(SB_SES, JSON.stringify(s)); else sessionStorage.removeItem(SB_SES); } catch (e) {} }
  async function sbAuth(grant, body) {
    const r = await fetch(SB_URL + '/auth/v1/token?grant_type=' + grant, { method: 'POST', headers: { apikey: SB_KEY, 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const d = await r.json().catch(() => ({}));
    if (!d.access_token) return null;
    const s = { at: d.access_token, rt: d.refresh_token, exp: Date.now() + (d.expires_in || 3600) * 1000 };
    sbSave(s);
    return s;
  }
  // Googleのログイン（IDトークン）を新しいデータ側のログインに替える。期限が近ければ裏で更新する
  async function sbToken() {
    let s = sbLoad();
    if (s && s.exp - Date.now() > 60000) return s.at;
    s = s && s.rt ? await sbAuth('refresh_token', { refresh_token: s.rt }) : null;
    if (!s && S.token) s = await sbAuth('id_token', { provider: 'google', id_token: S.token });
    return s ? s.at : '';
  }
  // データ側へ1回問い合わせる（呼び先だけを切り替える。返事の形はどちらも同じ）
  async function post(action, payload) {
    if (!DB_NEW) { const res = await fetch(API, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(Object.assign({ idToken: S.token, action }, payload || {})) }); return res.json(); }
    const at = await sbToken();
    if (!at) return { ok: false, reason: 'auth' };
    const res = await fetch(SB_FN, { method: 'POST', headers: { Authorization: 'Bearer ' + at, apikey: SB_KEY, 'Content-Type': 'application/json' }, body: JSON.stringify(Object.assign({ action }, payload || {})) });
    const d = await res.json();
    delete d.serverMs; // 速さの計測用。画面の「中身が変わったか」の比べに入れない
    return d;
  }

  const PREFS = ['北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県','茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県','新潟県','富山県','石川県','福井県','山梨県','長野県','岐阜県','静岡県','愛知県','三重県','滋賀県','京都府','大阪府','兵庫県','奈良県','和歌山県','鳥取県','島根県','岡山県','広島県','山口県','徳島県','香川県','愛媛県','高知県','福岡県','佐賀県','長崎県','熊本県','大分県','宮崎県','鹿児島県','沖縄県','海外'];
  const POSITIONS = ['登り職人','下り職人','夜間の番人','補給マスター','耐久王','案内人','ペーサー','旅人','盛り上げ役'];
  const TAG_GROUPS = [
    ['走り', ['登り','下り','テクニカル','ロード','夜間','暑さ','雪山','100マイル以上','ステージレース']],
    ['手伝えること', ['ペーサー','サポートクルー','試走案内','車出し','大会ボランティア']],
    ['詳しいこと', ['補給計画','ギア','海外エントリー','英語','写真と動画','ケアと治療','応急手当']],
  ];
  // 所属チーム（運営が名簿で設定）。帯の色＝チームカラー
  const TEAMS = {
    '京都': { en: 'KYOTO', color: '#5b2c83' },
    '東海': { en: 'TOKAI', color: '#0072bc' },
    '東京': { en: 'TOKYO', color: '#8c1c2b' },
    'オンライン': { en: 'ONLINE', color: '#141414' },
  };
  const TEAM_ORDER = Object.keys(TEAMS);
  const ROLE_ORDER = ['監督', 'ヘッドコーチ', 'コーチ', 'マネージャー'];
  const teamOf = p => (p.teams || []).find(t => TEAMS[t]) || '';
  const roleOf = p => (p.roles || [])[0] || '';
  const MAX_TAGS = 5;
  const POS_MAX = 8;
  const OTHER = '__other__';
  const RANK = {
    gold: { label: 'GOLD', title: 'ゴールド（殿堂入り）' }, silver: { label: 'SILVER', title: 'シルバーラメ' },
    bronze: { label: 'BRONZE', title: 'ブロンズ' }, normal: { label: '', title: 'ノーマル' },
  };
  // ポッドキャスト（一般公開ページ go-trail.net/pages/milers-podcast にも載る）
  const PODCASTS = [
    { key: 'pcStandfm', label: 'stand.fm', short: 'stand.fm', re: /^https:\/\/stand\.fm\//, ph: 'https://stand.fm/channels/…' },
    { key: 'pcSpotify', label: 'Spotify', short: 'Spotify', re: /^https:\/\/(open\.spotify\.com|spotify\.link|podcasters\.spotify\.com|creators\.spotify\.com)\//, ph: 'https://open.spotify.com/show/…' },
    { key: 'pcVoicy', label: 'Voicy', short: 'Voicy', re: /^https:\/\/(www\.)?voicy\.jp\//, ph: 'https://voicy.jp/channel/…' },
    { key: 'pcYoutube', label: 'YouTube', short: 'YouTube', re: /^https:\/\/((www|m)\.youtube\.com|youtu\.be)\//, ph: 'https://www.youtube.com/@…' },
  ];
  const PODCAST_PAGE = 'https://go-trail.net/pages/milers-podcast';
  const hasPodcast = p => !!p.pcTitle && PODCASTS.some(x => p[x.key]);
  const TRAIL_SIZE = [600, 838], TRAIL_MAX = 95000;
  const FACE_SIZE = [240, 300], FACE_MAX = 45000;

  const root = document.getElementById('milers-app');
  const S = { token: null, me: null, myProfile: null, cards: [], entries: [], races: [], rosterCount: 0, photos: {}, filter: { q: '', team: '', pref: '', race: '', tag: '', rank: '' } };

  // ---------- 小物 ----------
  // 「○○さん」の付け方。呼び名がもともと「さん・ちゃん・くん」などで終わる人には足さない（「久保さんさん」にしない）
  const honor = n => /(さん|ちゃん|くん|君|氏|様|さま|先生|監督|コーチ)$/.test(String(n || '').trim()) ? String(n).trim() : `${n}さん`;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const $ = (sel, el) => (el || root).querySelector(sel);
  const $$ = (sel, el) => Array.from((el || root).querySelectorAll(sel));
  const today = () => new Date();
  function season(d) { d = d || jstToday(); const y = d.getFullYear(); return d.getMonth() >= 5 ? `${y}-${String(y + 1).slice(2)}` : `${y - 1}-${String(y).slice(2)}`; }
  function toast(msg, ms) {
    const t = document.createElement('div'); t.className = 'mz-toast'; t.textContent = msg; t.setAttribute('role', 'status');
    document.body.appendChild(t); setTimeout(() => t.remove(), ms || 2800);
  }
  function fmtDate(iso) { const d = new Date(iso); return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; }

  // ---------- 表彰の略綬（りゃくじゅ） ----------
  // p.awards = [{ half:'2026-27 上半期', name:'敢闘賞', grade:3, colors:['#8c1c2b','#fff'], big:false }]
  // 色1〜3を、本物の略綬のように左右対称のしまにする
  function ribbonBg(colors) {
    const c = (colors || []).filter(Boolean);
    if (!c.length) return '#b9b4a6';
    if (c.length === 1) return c[0];
    const seq = c.length === 2 ? [[c[0], 0, 30], [c[1], 30, 70], [c[0], 70, 100]] : [[c[0], 0, 16], [c[1], 16, 32], [c[2], 32, 68], [c[1], 68, 84], [c[0], 84, 100]];
    return 'linear-gradient(90deg,' + seq.map(([x, a, b]) => `${x} ${a}% ${b}%`).join(',') + ')';
  }
  // 同じ名前の賞はまとめて1本にし、2回目からは「×2」のように回数を付ける。格の高い順（同じ格なら古い順）に上の段から
  function awardGroups(p) {
    const g = {};
    (p.awards || []).forEach(a => { const x = g[a.name] = g[a.name] || { name: a.name, grade: a.grade || 99, colors: a.colors, big: !!a.big, halves: [] }; x.halves.push(a.half); x.grade = Math.min(x.grade, a.grade || 99); x.big = x.big || !!a.big; });
    return Object.values(g).map(x => (x.halves.sort(), x)).sort((a, b) => a.grade - b.grade || a.halves[0].localeCompare(b.halves[0]));
  }
  const awardTip = x => `${x.halves.join('・')} ${x.name}`;
  function ribbonsHTML(p) {
    const list = awardGroups(p);
    if (!list.length) return '';
    // 1段に3本。端数は一番上の段に置き、真ん中にそろえる（本物の略綬の並べ方）
    const rows = []; let i = 0; const first = list.length % 3 || 3;
    rows.push(list.slice(0, first)); i = first;
    while (i < list.length) { rows.push(list.slice(i, i + 3)); i += 3; }
    return `<div class="rack" aria-label="受賞">${rows.map(r => `<div class="rrow">${r.map(x => `<span class="rb" role="button" tabindex="0" style="background:${ribbonBg(x.colors)}" data-tip="${esc(awardTip(x))}" title="${esc(awardTip(x))}">${x.halves.length > 1 ? `<i>×${x.halves.length}</i>` : ''}</span>`).join('')}</div>`).join('')}</div>`;
  }
  // 表面：大きな賞だけメダルを小さく
  function medalsHTML(p) {
    const big = awardGroups(p).filter(x => x.big).slice(0, 3);
    if (!big.length) return '';
    return `<div class="medals">${big.map(x => `<span class="medal" role="button" tabindex="0" data-tip="${esc(awardTip(x))}" title="${esc(awardTip(x))}"><span class="mr" style="background:${ribbonBg(x.colors)}"></span><span class="md">★</span></span>`).join('')}</div>`;
  }

  // ---------- ランク判定 ----------
  function ymDate(ym) { const [y, m] = String(ym).split('.').map(Number); return new Date(y, m - 1, 1); }
  function within2y(ym) { const lim = today(); lim.setFullYear(lim.getFullYear() - 2); return ymDate(ym) >= lim; }
  const isMile = r => Number(r.km) >= 160 && isItra(r.race);
  const raceKey = r => r.ym + '|' + normR(canonName(r.race));
  function judge(p) {
    const seen = new Set();
    const races = (p.races || []).filter(r => { if (!isMile(r)) return true; const k = raceKey(r); if (seen.has(k)) return false; seen.add(k); return true; });
    const ovMiles = races.filter(r => r.ov && isMile(r));
    const dmMiles = races.filter(r => !r.ov && isMile(r));
    // 殿堂入り（期限なし）：海外100マイル通算3本 または 国内100マイル通算6本
    const hof = [];
    if (ovMiles.length >= 3) hof.push({ n: ovMiles.length, label: '海外' });
    if (dmMiles.length >= 6) hof.push({ n: dmMiles.length, label: '国内' });
    if (hof.length) return { rank: 'gold', used: (ovMiles.length >= 3 ? ovMiles : []).concat(dmMiles.length >= 6 ? dmMiles : []), hof };
    const s = ovMiles.filter(r => within2y(r.ym));
    if (s.length) return { rank: 'silver', used: s };
    const b = races.filter(r => !r.ov && isMile(r) && within2y(r.ym));
    if (b.length) return { rank: 'bronze', used: b };
    return { rank: 'normal', used: [] };
  }

  // ---------- 通信 ----------
  // Google側の転送がまれにずれて、問い合わせが別の受け口に届く（unknown_action／JSONでない返事）。
  // そのときは少し待って1回だけやり直す。利用者には見せない
  const READ_ACTIONS = new Set(['list', 'me', 'photos', 'profile', 'history', 'pending', 'members']);
  // メンテナンス中の案内（2026-10-20 データ側が止まった件）。データ側の MAINT がオンのとき全画面に出す
  function showMaint() {
    if (document.getElementById('mz-maint')) return;
    document.body.insertAdjacentHTML('beforeend', '<div id="mz-maint" style="position:fixed;inset:0;z-index:99999;background:rgba(245,243,238,.97);display:flex;align-items:center;justify-content:center;padding:16px"><div style="max-width:420px;background:#fff;border-radius:14px;padding:24px 20px;box-shadow:0 4px 24px rgba(0,0,0,.12);text-align:center;font-size:15px;line-height:1.8;color:#222"><div style="font-weight:700;font-size:17px;margin-bottom:8px">ただいまメンテナンス中です</div>データの読み込みに不具合が出ているため、一時的に止めています。<br>直りしだい、FBグループでお知らせします。<br>これまでの記録は消えていません。</div></div>');
  }
  async function api(action, payload) {
    let d = null;
    for (let attempt = 0; attempt < 2; attempt++) {
      if (attempt) await new Promise(r => setTimeout(r, 800));
      try {
        d = await post(action, payload);
      } catch (e) {
        // 通信エラーのやり直しは読むだけの問い合わせに限る（保存や承認を二重にしない）
        if (attempt || !READ_ACTIONS.has(action)) throw e;
        continue;
      }
      if (!(d && !d.ok && d.reason === 'unknown_action')) break;
    }
    if (!d.ok && d.reason === 'maintenance') { showMaint(); throw new Error('maintenance'); }
    if (!d.ok && d.reason === 'auth') { logout('ログインの有効期限が切れました。もう一度ログインしてください。'); throw new Error('auth'); }
    return d;
  }

  // ---------- ログイン ----------
  function tokenExp(t) { try { return JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp * 1000; } catch (e) { return 0; } }
  // レース資料庫（milersLibTok）とログインを共有する。どちらかでログインしていれば、もう片方もそのまま入れる
  const LIB_KEY = 'milersLibTok';
  function storeToken(t) { S.token = t; try { sessionStorage.setItem(TOKEN_KEY, t); sessionStorage.setItem(LIB_KEY, t); } catch (e) {} }
  function loadToken() {
    try {
      const t = [sessionStorage.getItem(TOKEN_KEY), sessionStorage.getItem(LIB_KEY)].filter(Boolean).sort((a, b) => tokenExp(b) - tokenExp(a))[0];
      if (t && tokenExp(t) - Date.now() > 5 * 60 * 1000) return t;
    } catch (e) {}
    return null;
  }
  function logout(msg) { try { sessionStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(LIB_KEY); } catch (e) {} sbSave(null); S.token = null; showLogin(msg, true); }

  // LINE・Facebook・Instagram などのアプリ内ブラウザでは、Googleがログインを禁止している
  function inAppBrowser() {
    const ua = navigator.userAgent || '';
    if (/\bLine\//i.test(ua)) return 'LINE';
    if (/FBAN|FBAV|FB_IAB|FBIOS|Messenger/i.test(ua)) return 'Facebook';
    if (/Instagram/i.test(ua)) return 'Instagram';
    return '';
  }
  function showInApp(app) {
    const url = location.origin + location.pathname;
    root.innerHTML = `
      <div class="mz-login"><div class="box">
        <div class="eyebrow">TRAILFEST MILERS</div>
        <h1>マイラーズ選手名鑑</h1>
        <p class="err">${esc(app)}のアプリの中では、Googleのログインが使えません。</p>
        <p>SafariやChromeで開き直してください。<br>画面の右上や右下の「…」などから「ブラウザで開く」「Safariで開く」を選ぶか、下のボタンでURLをコピーしてブラウザに貼り付けてください。</p>
        <p><button class="mz-btn" id="mz-copy">URLをコピーする</button></p>
        <p style="font-size:12px;word-break:break-all">${esc(url)}</p>
      </div></div>`;
    $('#mz-copy').onclick = async () => {
      try { await navigator.clipboard.writeText(url); toast('コピーしました。SafariやChromeに貼り付けてください'); }
      catch (e) { toast('コピーできませんでした。下のURLを長押ししてコピーしてください'); }
    };
    // LINEは openExternalBrowser=1 を付けると外のブラウザで開き直せる
    if (app === 'LINE' && !/openExternalBrowser=1/.test(location.search)) {
      location.replace(url + '?openExternalBrowser=1');
    }
  }

  function showLogin(msg, isErr) {
    const app = inAppBrowser();
    if (app) return showInApp(app);
    root.innerHTML = `
      <div class="mz-login"><div class="box">
        <div class="eyebrow">TRAILFEST MILERS</div>
        <h1>マイラーズ選手名鑑</h1>
        <div class="gbtn" id="mz-gbtn"></div>
        <p class="${isErr ? 'err' : ''}" id="mz-login-msg">${esc(msg || 'マイラーズのメンバー限定です。Googleアカウントでログインしてください。')}</p>
        
      </div></div>`;
    whenGoogle(() => {
      google.accounts.id.initialize({ client_id: CLIENT_ID, callback: onCredential, auto_select: true, cancel_on_tap_outside: false });
      google.accounts.id.renderButton(document.getElementById('mz-gbtn'), { theme: 'filled_blue', size: 'large', text: 'signin_with', shape: 'pill', locale: 'ja' });
    });
  }
  function whenGoogle(fn) {
    if (window.google && google.accounts && google.accounts.id) return fn();
    setTimeout(() => whenGoogle(fn), 100);
  }
  async function onCredential(res) {
    storeToken(res.credential);
    const m = document.getElementById('mz-login-msg');
    if (m) { m.className = ''; m.textContent = '名簿を確認しています…'; }
    await start();
  }

  async function start() {
    let d;
    try { d = await api('list'); } catch (e) { if (e.message !== 'auth') showLogin('通信できませんでした。電波の良いところでもう一度お試しください。', true); return; }
    if (!d.ok) {
      if (d.reason === 'not_member') return showRequest(d.email, d.request, d);
      return showLogin('エラーが発生しました（' + (d.reason || '') + '）。時間をおいてもう一度お試しください。', true);
    }
    S.me = d.me; S.cards = d.cards; S.entries = d.entries || []; S.races = d.races; S.rosterCount = d.rosterCount; S.pendingCount = d.pendingCount || 0; S.pendingRaces = d.pendingRaces || 0; S.weeklyNotice = d.weeklyNotice || null; S.reactNotice = d.reactNotice || null; S.ideaCount = d.ideaCount || 0; if (!IDEA.list) setTimeout(() => loadIdeas(null), 1500);
    S.myProfile = S.cards.find(c => c.email === S.me.email) || null;
    renderApp();
    loadLibrary();
    loadDbRaces();
    const want = (new URLSearchParams(location.search).get('card') || '').toLowerCase();
    if (want && S.cards.some(c => c.email === want)) openViewer(want, true);
    const qs = new URLSearchParams(location.search);
    if (qs.get('open') === 'races' || qs.get('view') === 'races') openBoard(); // ?view= は Shopify が別ひな形の合図に使うので ?open= を使う（2026-10-20）
    if (qs.get('open') === 'calendar') openCalendar(); // カレンダー（2026-11-03）
    if (qs.get('open') === 'ideas') openIdeas();
    else if (qs.get('entry')) goEntry(qs.get('entry'));
  }

  // ---------- 参加申請（名簿にない人） ----------
  function switchAccount() {
    try { sessionStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(LIB_KEY); } catch (e) {}
    sbSave(null);
    S.token = null;
    if (window.google && google.accounts) google.accounts.id.disableAutoSelect();
    showLogin('ログインし直すGoogleアカウントを選んでください。');
  }
  function showRequest(email, req, info) {
    info = info || {};
    const head = `<div class="eyebrow">TRAILFEST MILERS</div><h1>マイラーズ選手名鑑</h1>`;
    const other = `<p><button class="mz-btn ghost" id="mz-switch" style="color:var(--navy)">別のアカウントでログインし直す</button></p>`;
    if (req && req.status === '承認待ち') {
      root.innerHTML = `<div class="mz-login"><div class="box">${head}
        <p><b>参加申請を受け付けています。</b><br>運営が承認すると使えるようになります。しばらくしてから、このページを開き直してください。</p>
        <p style="font-size:12px">申請したアカウント：${esc(email)}</p>
        <p><button class="mz-btn" id="mz-reload">承認されたか確かめる</button></p>${other}</div></div>`;
      $('#mz-reload').onclick = () => { root.innerHTML = '<div class="mz-loading">確認しています…</div>'; start(); };
      $('#mz-switch').onclick = switchAccount;
      return;
    }
    if (req && req.status === '見送り') {
      root.innerHTML = `<div class="mz-login"><div class="box">${head}
        <p class="err">このアカウント（${esc(email)}）では名鑑を利用できません。</p>
        <p>マイラーズのメンバーの方は、運営にお問い合わせください。</p>${other}</div></div>`;
      $('#mz-switch').onclick = switchAccount;
      return;
    }
    if (info.closed) {
      root.innerHTML = `<div class="mz-login"><div class="box">${head}
        <p class="err">参加申請の受付は ${esc(info.deadline || '')} で終了しました。</p>
        <p>マイラーズのメンバーの方は、運営（trailfestrunningcompany@gmail.com）にお問い合わせください。</p>
        <p style="font-size:12px">ログイン中のアカウント：${esc(email)}</p>${other}</div></div>`;
      $('#mz-switch').onclick = switchAccount;
      return;
    }
    root.innerHTML = `<div class="mz-login"><div class="box" style="text-align:left">${head.replace('<h1>', '<h1 style="text-align:center">').replace('class="eyebrow"', 'class="eyebrow" style="text-align:center"')}
      <p style="margin-top:0">名鑑を使うには、最初に<b>参加申請</b>が必要です。運営が承認すると使えるようになります。</p>
      ${info.deadline ? `<p style="margin:0"><b>参加申請の受付は ${esc(info.deadline)} までです。</b></p>` : ''}
      <p style="font-size:12px">ログイン中のアカウント：${esc(email)}<br>いつも使っているGoogleアカウントでない場合は、下の「別のアカウントでログインし直す」から選び直してください。</p>
      <form id="mz-req" class="mz-form" style="margin-top:14px;gap:12px" novalidate>
        <label class="mz-field"><span>名前（フルネーム）<em>必須</em></span><input name="name" maxlength="30" placeholder="例：山本 健太" autocomplete="name"></label>
        <label class="mz-field"><span>所属チーム<em>必須</em></span><select name="team"><option value="">選んでください</option>${TEAM_ORDER.map(t => `<option>${t}</option>`).join('')}</select></label>
        <label class="mz-field"><span>運営へのひとこと（任意）</span><input name="note" maxlength="80" placeholder="例：東海の練習会に参加しています"></label>
        <div id="mz-req-err"></div>
        <button class="mz-btn" type="submit">参加申請する</button>
      </form>${other}</div></div>`;
    $('#mz-switch').onclick = switchAccount;
    $('#mz-req').onsubmit = async e => {
      e.preventDefault();
      const f = e.target, name = f.name.value.trim(), team = f.team.value, note = f.note.value.trim();
      if (!name || !team) { $('#mz-req-err').innerHTML = '<div class="mz-errors">名前と所属チームを入れてください</div>'; return; }
      const b = f.querySelector('button[type=submit]'); b.disabled = true; b.textContent = '送っています…';
      try {
        const r = await api('request', { name, team, note });
        if (!r.ok) throw new Error(r.reason);
        showRequest(email, r.request);
      } catch (err) {
        if (err.message === 'auth') return;
        if (err.message === 'closed') return showRequest(email, null, Object.assign({}, info, { closed: true }));
        b.disabled = false; b.textContent = '参加申請する';
        $('#mz-req-err').innerHTML = '<div class="mz-errors">送れませんでした。電波の良いところでもう一度お試しください。</div>';
      }
    };
  }

  // ---------- レース整理（管理者） ----------
  async function openRaceAdmin() {
    const wrap = document.createElement('div');
    wrap.className = 'mz-editor';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', 'レース整理');
    wrap.innerHTML = `<div class="bar"><b>レース整理</b><button class="mz-btn ghost" id="r-close">閉じる</button></div><div class="body"><div class="mz-loading">読み込んでいます…</div></div>`;
    root.appendChild(wrap);
    document.body.style.overflow = 'hidden';
    let changed = false;
    const close = async () => { wrap.remove(); document.body.style.overflow = ''; if (changed) await reloadList(); };
    $('#r-close', wrap).onclick = close;
    let d;
    try { d = await api('racesPending'); } catch (e) { return; }
    if (!d.ok) { $('.body', wrap).innerHTML = '<div class="mz-loading">読み込めませんでした</div>'; return; }
    const confirmed = d.all.filter(r => !r.pending).sort((a, b) => a.name.localeCompare(b.name, 'ja'));
    const body = $('.body', wrap);
    // 似ている順に、まとめる先の候補を並べる
    const similar = name => { const k = normR(name); return confirmed.map(r => { const ks = [r.name].concat(r.aliases || []).map(normR); const sc = ks.some(x => x && (x.includes(k.slice(0, 4)) || k.includes(x.slice(0, 4)))) ? 0 : 1; return { r, sc }; }).sort((a, b) => a.sc - b.sc || a.r.name.localeCompare(b.r.name, 'ja')).map(x => x.r); };
    const draw = () => {
      body.innerHTML = `<div class="cols" style="grid-template-columns:1fr;max-width:760px"><div class="mz-form">
        <div class="mz-sec"><h3>確認中のレース（${d.races.length}件）</h3>
          <p class="hint">メンバーからの「大会の追加依頼」（<b>依頼</b>）と、前にメンバーが打ち込んだ名前（未確認）が並びます。すでにあるレースの書き方違いなら「まとめる」、新しいレースなら国内／海外を確かめて「登録する」を押してください。登録すると、メンバーが候補から選べるようになります。まとめると、そのレースを入れた人の戦績も正式名に直ります。</p>
          ${d.races.length ? '' : '<p class="hint"><b>確認中のレースはありません。</b></p>'}
        </div>
        ${d.races.map((r, i) => `<div class="mz-sec" data-i="${i}">
          <h3>${r.requested ? '<span class="mz-reqtag">依頼</span>' : ''}${esc(r.name)}</h3><p class="hint">${r.requested ? esc(r.memo || '') : `戦績で${r.uses}件使われています`}</p>
          <div class="mz-2col">
            <label class="mz-field"><span>まとめる先（書き方違いのとき）</span><select data-f="target"><option value="">選んでください</option>${similar(r.name).map(x => `<option>${esc(x.name)}</option>`).join('')}</select></label>
            <label class="mz-field"><span>国内／海外（新しく登録するとき）</span><select data-f="ov"><option value="0"${!r.ov ? ' selected' : ''}>国内</option><option value="1"${r.ov ? ' selected' : ''}>海外</option></select></label>
          </div>
          <div class="mz-actions" style="padding:0">${r.requested ? '<button type="button" class="mz-btn ghost" data-act="decline" style="color:var(--navy)">見送る</button>' : ''}<button type="button" class="mz-btn ghost" data-act="merge" style="color:var(--navy)">まとめる</button><button type="button" class="mz-btn" data-act="approve">新しいレースとして登録する</button></div>
        </div>`).join('')}
        <div class="mz-sec"><h3>全員の戦績をそろえる</h3>
          <p class="hint">スプレッドシートの「レース一覧」タブで別名を足したあとに押すと、全員の戦績のレース名と国内／海外を一覧に合わせて直します。押す前の戦績は、スプレッドシートに「戦績の控え」として残ります。</p>
          <div class="mz-actions" style="padding:0"><span></span><button type="button" class="mz-btn" id="r-unify">全員の戦績をそろえる</button></div>
        </div>
      </div></div>`;
    };
    draw();
    body.addEventListener('click', async e => {
      if (e.target.id === 'r-unify') {
        if (!confirm('全員の戦績のレース名を、レース一覧に合わせて直します。よろしいですか？')) return;
        e.target.disabled = true; e.target.textContent = '直しています…';
        try { const r = await api('racesUnify'); if (!r.ok) throw new Error(r.reason); toast(r.warning ? `${r.changed}人分の戦績を直しました。ただし出場予定の大会名は書き換えられませんでした。少し時間をおいて、もう一度押してください` : `${r.changed}人分の戦績を直しました`); changed = true; }
        catch (err) { if (err.message !== 'auth') toast('できませんでした（' + err.message + '）'); }
        e.target.disabled = false; e.target.textContent = '全員の戦績をそろえる';
        return;
      }
      const b = e.target.closest('[data-act]'); if (!b) return;
      const sec = b.closest('[data-i]'), r = d.races[Number(sec.dataset.i)];
      const target = $('[data-f=target]', sec).value, ov = $('[data-f=ov]', sec).value === '1';
      if (b.dataset.act === 'merge' && !target) return toast('まとめる先のレースを選んでください');
      b.disabled = true;
      try {
        if (b.dataset.act === 'decline' && !confirm(`「${r.name}」の追加依頼を見送りますか？`)) { b.disabled = false; return; }
        const res = await api('raceResolve', b.dataset.act === 'merge' ? { name: r.name, mode: 'merge', target } : b.dataset.act === 'decline' ? { name: r.name, mode: 'decline' } : { name: r.name, mode: 'approve', ov });
        if (!res.ok) throw new Error(res.reason);
        toast((b.dataset.act === 'merge' ? `「${r.name}」を「${target}」にまとめました` : b.dataset.act === 'decline' ? `「${r.name}」を見送りました` : `「${r.name}」を登録しました`)
          + (res.warning ? '。ただし出場予定の大会名は書き換えられませんでした。下の「全員の戦績をそろえる」を押してやり直してください' : ''), res.warning ? 8000 : undefined);
        changed = true; d.races.splice(Number(sec.dataset.i), 1); draw();
      } catch (err) { if (err.message !== 'auth') { b.disabled = false; toast('できませんでした（' + err.message + '）'); } }
    });
  }

  // ---------- 承認（管理者） ----------
  async function openApprovals() {
    const wrap = document.createElement('div');
    wrap.className = 'mz-editor';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', '参加申請の承認');
    wrap.innerHTML = `<div class="bar"><b>参加申請の承認</b><button class="mz-btn ghost" id="a-close">閉じる</button></div><div class="body"><div class="mz-loading">読み込んでいます…</div></div>`;
    root.appendChild(wrap);
    document.body.style.overflow = 'hidden';
    const close = async changed => { wrap.remove(); document.body.style.overflow = ''; if (changed) await reloadList(); };
    let changed = false;
    $('#a-close', wrap).onclick = () => close(changed);
    let d;
    try { d = await api('pending'); } catch (e) { return; }
    const body = $('.body', wrap);
    const draw = () => {
      if (!d.requests.length) { body.innerHTML = '<div class="mz-loading">承認待ちの申請はありません</div>'; return; }
      body.innerHTML = `<div class="cols" style="grid-template-columns:1fr;max-width:720px"><div class="mz-form">${d.requests.map((r, i) => `
        <div class="mz-sec" data-i="${i}">
          <h3>${esc(r.name)}</h3>
          <p class="hint">${esc(r.email)}　申請：${fmtDate(r.at)}${r.note ? `<br>ひとこと：${esc(r.note)}` : ''}</p>
          <div class="mz-2col">
            <label class="mz-field"><span>所属</span><select data-f="team">${TEAM_ORDER.map(t => `<option${t === r.team ? ' selected' : ''}>${t}</option>`).join('')}</select></label>
            <label class="mz-field"><span>役職</span><select data-f="role"><option value="">なし</option>${ROLE_ORDER.map(t => `<option>${t}</option>`).join('')}</select></label>
          </div>
          <div class="mz-actions" style="padding:0">
            <button type="button" class="mz-btn ghost" data-act="decline" style="color:var(--sub)">見送る</button>
            <button type="button" class="mz-btn" data-act="approve">承認する</button>
          </div>
        </div>`).join('')}</div></div>`;
    };
    draw();
    body.addEventListener('click', async e => {
      const b = e.target.closest('[data-act]'); if (!b) return;
      const sec = b.closest('[data-i]'), r = d.requests[Number(sec.dataset.i)];
      if (b.dataset.act === 'decline' && !confirm(`${r.name}さん（${r.email}）の申請を見送りますか？`)) return;
      b.disabled = true;
      try {
        const res = b.dataset.act === 'approve'
          ? await api('approve', { email: r.email, team: $('[data-f=team]', sec).value, role: $('[data-f=role]', sec).value })
          : await api('decline', { email: r.email });
        if (!res.ok) throw new Error(res.reason);
        toast(b.dataset.act === 'approve' ? `${r.name}さんを承認しました（No.${String(res.no).padStart(3, '0')}）` : '見送りました');
        changed = true;
        d.requests.splice(Number(sec.dataset.i), 1);
        draw();
      } catch (err) { if (err.message !== 'auth') { b.disabled = false; toast('できませんでした（' + err.message + '）'); } }
    });
  }

  // ---------- レースのデータベース ----------
  const normR = x => String(x || '').normalize('NFKC').toLowerCase().replace(/[\s・･\-‐－―_.,、。!！?？'’"“”()（）［］\[\]「」『』&＆/／:：~〜]/g, '');
  function raceIdx() {
    if (S._ridxFor === S.races && S._ridx) return S._ridx;
    const idx = Object.create(null);
    (S.races || []).forEach(r => [r.name, r.short].concat(r.aliases || []).forEach(a => { const k = normR(a); if (k && !idx[k]) idx[k] = r; }));
    S._ridx = idx; S._ridxFor = S.races;
    return idx;
  }
  // レースデータベース（go-trail.net/pages/race-db-top）の全大会。名鑑の一覧にない大会も候補に出す（2026-10-08）
  const DB_NAMES_URL = 'https://cdn.shopify.com/s/files/1/0631/9128/5922/t/2/assets/race-db-names.json';
  let DB_RACES = null, DB_IDX = null, DB_READY = false;
  // 名鑑を開いたときに読む（「あなたの大会」の候補・公式サイト・天気予報の場所に使う）。読み終わりを待てるよう Promise を返す
  let DB_P = null;
  function loadDbRaces() {
    if (DB_RACES && DB_P) return DB_P;
    DB_RACES = [];
    // ShopifyのCDNは ?v= だけで新旧を見分ける（ほかの付け足しは無視して古いものを返す）。1時間ごとに最新を読む
    DB_P = fetch(DB_NAMES_URL + '?v=' + todayStr().replace(/-/g, '') + String(new Date().getHours()).padStart(2, '0') + Math.floor(new Date().getMinutes() / 10)).then(r => r.json()).then(list => {
      DB_RACES = list.map(x => ({ name: x.n, ov: !!x.ov, aliases: x.a || [], short: '', itra: '', pending: false, db: true, url: x.u || '', pos: x.p || null, cats: (x.c || []).map(([label, km, url]) => ({ label, km, url: url || '' })) }));
      DB_IDX = null; DB_READY = true;
      // 読み込み前に描いた「一覧にありません」を直す（入力中の欄は崩さない）
      const busy = el => el && el.contains(document.activeElement);
      if (E && E.wrap && $('#e-races', E.wrap) && !busy($('#e-races', E.wrap))) rerenderRaces();
      if (EC.box && $('#n-form', EC.box) && !busy($('#n-form', EC.box)) && N && N.race) rerenderEntryForm();
      const tw = $('#mz-my .mz-teamwk'); if (tw) tw.outerHTML = teamWeekHTML(); // 大会名に公式サイトのリンクを付け直す
    }).catch(() => { DB_RACES = null; DB_P = null; DB_READY = true; }); // 読めなかったら、次に開いたときに読み直す（保存の可否はデータ側が確かめる）
    return DB_P;
  }
  // レースDBの公式サイト・場所。名鑑のレース一覧の名前（別名・表示名）からもたどる
  function dbInfo(name) {
    const cands = [name];
    const k = (S.races || []).find(r => normR(r.name) === normR(name));
    if (k) cands.push(k.short, ...(k.aliases || []));
    for (const c of cands) { const h = c && dbIdx()[normR(c)]; if (h) return h; }
    return null;
  }
  function dbIdx() {
    if (DB_IDX) return DB_IDX;
    DB_IDX = Object.create(null);
    (DB_RACES || []).forEach(r => [r.name, ...r.aliases].forEach(n => { const k = normR(n); if (k && !DB_IDX[k]) DB_IDX[k] = r; })); // 別名（DBで1つにまとめた大会の、もう一方の名前）でも引ける
    return DB_IDX;
  }
  const findRace = name => raceIdx()[normR(name)] || dbIdx()[normR(name)] || null;
  const canonName = name => { const r = findRace(name); return r ? r.name : name; };
  const dispName = name => { const r = findRace(name); return r ? (r.short || r.name) : name; };
  // ITRAに登録されているレースか（データベースにITRAのページがあるもの）。ITRA外はランクに数えない
  const isItra = race => { const r = findRace(race); return !!(r && r.itra && !r.pending); };
  // 打った文字に合うレース（正式名・別名のどちらでも）
  function suggestRaces(q) {
    const k = normR(q);
    if (!k) return [];
    const hits = [];
    (S.races || []).forEach(r => {
      const names = [r.name, r.short].filter(Boolean).concat(r.aliases || []);
      const ks = names.map(normR);
      const score = ks.some(x => x === k) ? 0 : ks.some(x => x.startsWith(k)) ? 1 : ks.some(x => x.includes(k)) ? 2 : -1;
      if (score >= 0) hits.push({ r, score });
    });
    const idx = raceIdx();
    (DB_RACES || []).forEach(r => {
      if (idx[normR(r.name)]) return;
      const x = normR(r.name);
      const score = x === k ? 0 : x.startsWith(k) ? 1 : x.includes(k) ? 2 : -1;
      if (score >= 0) hits.push({ r, score: score + 0.5 });
    });
    const out = hits.sort((a, b) => a.score - b.score || a.r.name.localeCompare(b.r.name, 'ja')).slice(0, 10).map(h => h.r);
    // 見つからないときは、後ろの距離（「Tamba200k」「KGR130」「彩の国100M」の 200k・130・100M など）を外して探し直す
    if (!out.length) {
      const q2 = String(q).replace(/[\s\-_]*\d+(\.\d+)?\s*(k|km|㎞|mile|miles|mi|m|マイル|キロ)?\s*$/i, '').trim();
      if (q2 && q2 !== String(q).trim() && normR(q2).length >= 2) return suggestRaces(q2);
    }
    return out;
  }

  // ---------- レース資料庫との突き合わせ ----------
  const normRace = x => String(x || '').toLowerCase().replace(/[\s　（）()［］\[\]「」・\-‐－_.,、。!！]/g, '');
  async function loadLibrary() {
    try {
      const r = await fetch(LIB_API, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ idToken: S.token, action: 'list' }) });
      const d = await r.json();
      if (!d.ok || !Array.isArray(d.docs)) return;
      S.docsByEmail = {};
      d.docs.forEach(doc => { const e = String(doc.email || '').toLowerCase(); (S.docsByEmail[e] = S.docsByEmail[e] || []).push(doc); });
      if (V) V.draw();
    } catch (e) { /* 資料庫に届かなくても名鑑はそのまま使える */ }
  }
  // 戦績の1行に対応する資料（同じ人・同じ年月・レース名が似ている）
  function docsForRace(email, r) {
    const docs = (S.docsByEmail || {})[String(email).toLowerCase()] || [];
    const ym = String(r.ym || '').replace('.', '-');
    const a = normRace(r.race);
    const sameMonth = docs.filter(d => String(d.date || '').slice(0, 7) === ym);
    const byName = sameMonth.filter(d => { const b = normRace(d.race); return b && a && (a.includes(b) || b.includes(a)); });
    const hit = byName.length ? byName : (new Set(sameMonth.map(d => normRace(d.race))).size === 1 ? sameMonth : []);
    return { report: hit.find(d => d.kind === '報告書'), plan: hit.find(d => d.kind === '計画書') };
  }

  // ---------- カード ----------
  function placeholderTrail() {
    return `<svg viewBox="0 0 300 420" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="300" height="420" fill="#cfd8de"/><path d="M0 230 L70 150 L120 200 L180 110 L240 180 L300 140 L300 420 L0 420Z" fill="#9aa7b0"/>
      <path d="M0 290 L80 230 L150 270 L220 220 L300 260 L300 420 L0 420Z" fill="#6f7f86"/></svg>`;
  }
  function placeholderFace() {
    return `<svg viewBox="0 0 74 92" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="74" height="92" fill="#cfd3db"/>
      <circle cx="37" cy="36" r="16" fill="#8d94a3"/><path d="M8 92 C10 66 22 58 37 58 C52 58 64 66 66 92Z" fill="#8d94a3"/></svg>`;
  }

  // p=プロフィール, ph={face,trail} 写真（dataURL）。写真がまだ届いていなければ仮の絵
  function cardHTML(p, ph, opts) {
    opts = opts || {};
    const j = judge(p);
    const no = 'No.' + String(p.no || 0).padStart(3, '0');
    const races = (p.races || []).slice().sort((a, b) => String(b.ym).localeCompare(String(a.ym)));
    const shown = races.slice(0, 5);
    const usedKey = new Set(j.used.map(raceKey));
    const rows = shown.map(r => {
      const cls = isMile(r) && usedKey.has(raceKey(r)) ? 'hl' : (!within2y(r.ym) ? 'old' : '');
      const tags = (r.ov ? '<span class="tag ov">海外</span>' : '') + (isMile(r) ? '<span class="tag mi">100mi</span>' : '');
      const dd = opts.docs ? docsForRace(p.email, r) : {};
      const links = (dd.report ? `<a class="doc" href="${LIB_URL}?doc=${encodeURIComponent(dd.report.id)}">報告書</a>` : '')
        + (dd.plan ? `<a class="doc plan" href="${LIB_URL}?doc=${encodeURIComponent(dd.plan.id)}">計画書</a>` : '');
      return `<tr class="${cls}"><td class="y">${esc(r.ym)}</td><td>${esc(dispName(r.race))}${tags}${isItra(r.race) ? '' : '<span class="tag nx" title="ITRAに登録されていないレース（ランクには数えません）">ITRA外</span>'}${links}</td><td class="r">${esc(r.km)}km</td><td class="r">${esc(r.time)}</td></tr>`;
    }).join('');
    const area = [p.pref, p.city].filter(Boolean).join(' ');
    const team = teamOf(p), tc = team ? TEAMS[team].color : '#0a1020';
    const teamNames = (p.teams || []).filter(t => TEAMS[t]);
    const role = roleOf(p);
    const trail = ph && ph.trail ? `<img src="${esc(ph.trail)}" alt="" loading="lazy">` : placeholderTrail();
    const face = ph && ph.face ? `<img src="${esc(ph.face)}" alt="${esc(p.name)}の顔写真" loading="lazy">` : placeholderFace();
    return `
    <div class="mz-card ${j.rank}${opts.flipped ? ' flipped' : ''}" style="--tc:${tc}" role="button" tabindex="0" data-email="${esc(p.email)}" aria-label="${esc(p.name)}のカード（タップで裏返す）">
      <div class="inner">
        <div class="face front"><div class="photo">
          ${trail}<div class="sparkle"></div>
          <span class="no">${no}</span>${role ? `<span class="role">${esc(role)}</span>` : ''}
          ${RANK[j.rank].label ? `<span class="rank">${RANK[j.rank].label}</span>` : ''}
          <div class="band">
            ${nextBadge(p.email)}
            ${team ? `<div class="team">MILERS ${teamNames.map(t => TEAMS[t].en).join(' / ')}</div>` : ''}
            ${p.pos ? `<span class="pos">${esc(p.pos)}</span>` : ''}
            <div class="name">${esc(p.name || '名前')}${p.nick ? `<span class="nick">「${esc(p.nick)}」</span>` : ''}</div>
            <div class="area">${esc(area)}</div>
            <div class="roman">${esc(String(p.roman || '').toUpperCase())}</div>
          </div>
          ${medalsHTML(p)}
          ${j.rank === 'gold' ? `<div class="counts">${j.hof.map(h => `<div class="count"><b>${h.n}</b><span>${h.label}<br>100mi</span></div>`).join('')}</div>` : ''}
        </div></div>
        <div class="face back"><div class="sheet">
          <div class="bhead"><span class="bn">${esc(p.name || '名前')}</span><span class="bno">${no}</span></div>
          <div class="prof">
            <div class="mug">${face}</div>
            <dl>
              ${team ? `<dt>所属</dt><dd>${esc(teamNames.join('・'))}${role ? '　' + esc(role) : ''}</dd>` : ''}
              <dt>呼び名</dt><dd>${esc(p.nick)}</dd>
              <dt>地域</dt><dd>${esc(area)}</dd>
              <dt>トレラン歴</dt><dd>${p.since ? esc(p.since) + '年〜' : ''}</dd>
              <dt>得意</dt><dd>${esc((p.tags || []).join('・'))}</dd>
              <dt>次の目標</dt><dd>${esc(p.goal)}</dd>
            </dl>
          </div>
          ${ribbonsHTML(p) ? `<div class="awards"><span class="sec">勲 章</span>${ribbonsHTML(p)}</div>` : ''}
          <span class="sec">戦 績</span>
          <div class="tbl"><table><thead><tr><th>年月</th><th>レース</th><th class="r">距離</th><th class="r">記録</th></tr></thead><tbody>${rows}</tbody></table>
          ${races.length > shown.length ? `<div class="more">ほか${races.length - shown.length}レース</div>` : ''}</div>
          ${p.comment ? `<div class="comment">${esc(p.comment)}</div>` : ''}
          ${hasPodcast(p) ? `<div class="pod"><span class="pt">🎙 ${esc(p.pcTitle)}</span>${PODCASTS.filter(x => p[x.key]).map(x => `<a class="doc" href="${esc(p[x.key])}" target="_blank" rel="noopener">${x.short}</a>`).join('')}</div>` : ''}
          <div class="foot"><span>TRAILFEST MILERS</span><span>${season()}</span></div>
        </div></div>
      </div>
    </div>`;
  }

  // ---------- 一覧画面 ----------
  function renderApp() {
    const registered = S.cards.length;
    root.innerHTML = `
      <header class="mz-head"><div class="row">
        <div class="ttl"><small>TRAILFEST MILERS ${season()}</small><b>マイラーズ選手名鑑</b></div>
        <span class="count">${registered} / ${S.rosterCount}人</span>
        <nav class="links"><a href="https://go-trail.net/pages/milers-directory">選手名鑑</a><a href="https://go-trail.net/pages/milers-training">練習記録</a><a href="https://go-trail.net/pages/milers-training?tab=practice">練習会</a><a href="https://go-trail.net/pages/milers-training?tab=courses">コース</a><a href="?open=races" id="mz-board">大会予定・結果</a><a href="?open=calendar" id="mz-cal">カレンダー</a><a href="https://go-trail.net/pages/milers-library">レース資料庫</a><a href="https://go-trail.net/pages/milers-guide">使い方</a><a href="?open=ideas" id="mz-ideas">💡 要望</a></nav>
        ${S.me.admin && S.ideaCount ? `<button class="mz-btn light" id="mz-ideas2">要望 ${S.ideaCount}件</button>` : ''}
        ${S.me.admin && S.pendingCount ? `<button class="mz-btn light" id="mz-pending">承認待ち ${S.pendingCount}人</button>` : ''}
        ${S.me.admin ? `<button class="mz-btn light" id="mz-races">レース整理${S.pendingRaces ? ` ${S.pendingRaces}` : ''}</button>` : ''}
        <button class="mz-btn${S.myProfile ? ' light' : ''}" id="mz-edit">${S.myProfile ? '自分のカードを編集' : '自分のカードを作る'}</button>
      </div></header>
      <div id="mz-my"></div>
      ${calTopHTML()}
      ${S.myProfile ? '' : `<div class="mz-notice"><div><span>まだあなたのカードがありません。写真2枚と代表的なレースを入れて、名鑑に参加しましょう（5分ほどで終わります）。</span><button class="mz-btn" id="mz-edit2">カードを作る</button></div></div>`}
      <div class="mz-filters" role="search">
        <input type="search" id="f-q" placeholder="名前・呼び名・地域・ひとことで探す" value="${esc(S.filter.q)}" aria-label="キーワード">
        <select id="f-team" aria-label="所属"><option value="">所属チーム</option>${TEAM_ORDER.map(t => `<option${t === S.filter.team ? ' selected' : ''}>${t}</option>`).join('')}<option value="__staff"${S.filter.team === '__staff' ? ' selected' : ''}>監督・コーチ・マネージャー</option></select>
        <select id="f-pref" aria-label="地域"><option value="">地域</option>${[...new Set(S.cards.map(c => c.pref).filter(Boolean))].sort((a, b) => PREFS.indexOf(a) - PREFS.indexOf(b)).map(v => `<option${v === S.filter.pref ? ' selected' : ''}>${esc(v)}</option>`).join('')}</select>
        <select id="f-race" aria-label="走ったレース"><option value="">走ったレース</option>${[...new Set(S.cards.flatMap(c => (c.races || []).map(r => canonName(r.race))))].sort().map(v => `<option value="${esc(v)}"${v === S.filter.race ? ' selected' : ''}>${esc(dispName(v))}</option>`).join('')}</select>
        <select id="f-tag" aria-label="得意なこと"><option value="">得意なこと</option>${TAG_GROUPS.map(([g, tags]) => `<optgroup label="${esc(g)}">${tags.map(t => `<option${t === S.filter.tag ? ' selected' : ''}>${esc(t)}</option>`).join('')}</optgroup>`).join('')}</select>
        <select id="f-rank" aria-label="ランク"><option value="">ランク</option>${['gold', 'silver', 'bronze', 'normal'].map(k => `<option value="${k}"${k === S.filter.rank ? ' selected' : ''}>${RANK[k].title}</option>`).join('')}</select>
        <span class="hits" id="mz-hits"></span>
      </div>
      <main class="mz-grid" id="mz-grid"></main>`;
    $('#mz-edit').onclick = () => openEditor(S.me.email);
    $('#mz-board').onclick = e => { e.preventDefault(); openBoard(); };
    $('#mz-ideas').onclick = e => { e.preventDefault(); openIdeas(); };
    $('#mz-cal').onclick = e => { e.preventDefault(); openCalendar(); };
    if ($('#mz-cal2')) $('#mz-cal2').onclick = () => openCalendar();
    if ($('#mz-ideas2')) $('#mz-ideas2').onclick = () => openIdeas();

    if ($('#mz-pending')) $('#mz-pending').onclick = openApprovals;
    if ($('#mz-races')) $('#mz-races').onclick = openRaceAdmin;
    if ($('#mz-edit2')) $('#mz-edit2').onclick = () => openEditor(S.me.email);
    $('#f-q').oninput = e => { S.filter.q = e.target.value; renderGrid(); };
    ['team', 'pref', 'race', 'tag', 'rank'].forEach(k => { $('#f-' + k).onchange = e => { S.filter[k] = e.target.value; renderGrid(); }; });
    const grid = $('#mz-grid');
    grid.addEventListener('click', e => {
      const c = e.target.closest('.mz-card'); if (!c) return;
      // 次戦バッジを押したら、その人の出場予定・結果を開く（カードの拡大ではなく）
      if (e.target.closest('.next')) { const p = S.cards.find(x => x.email === c.dataset.email); if (p) openPersonEntries(p); return; }
      openViewer(c.dataset.email);
    });
    grid.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('mz-card')) { e.preventDefault(); openViewer(e.target.dataset.email); } });
    renderGrid();
    renderMyRaces();
  }

  function matches(c) {
    const f = S.filter;
    if (f.team === '__staff' && !roleOf(c)) return false;
    if (f.team && f.team !== '__staff' && !(c.teams || []).includes(f.team)) return false;
    if (f.pref && c.pref !== f.pref) return false;
    if (f.race && !(c.races || []).some(r => canonName(r.race) === f.race)) return false;
    if (f.tag && !(c.tags || []).includes(f.tag)) return false;
    if (f.rank && judge(c).rank !== f.rank) return false;
    if (f.q) {
      const hay = [c.name, c.nick, c.roman, c.pref, c.city, c.comment, c.goal, c.pos, c.pcTitle].join(' ').toLowerCase();
      if (!f.q.toLowerCase().split(/\s+/).filter(Boolean).every(w => hay.includes(w))) return false;
    }
    return true;
  }

  function sortKey(c) {
    const t = TEAM_ORDER.indexOf(teamOf(c)), r = ROLE_ORDER.indexOf(roleOf(c));
    return [t < 0 ? 99 : t, r < 0 ? 99 : r, c.no || 9999];
  }
  function byTeam(a, b) { const x = sortKey(a), y = sortKey(b); return x[0] - y[0] || x[1] - y[1] || x[2] - y[2]; }

  function renderGrid() {
    const list = S.cards.filter(matches).sort(byTeam);
    $('#mz-hits').textContent = `${list.length}人`;
    const grid = $('#mz-grid');
    grid.innerHTML = list.length ? list.map(c => cardHTML(c, S.photos[c.email])).join('') : `<div class="mz-empty">${S.cards.length ? '条件に合うメンバーがいません' : 'まだ誰もカードを作っていません。最初の1枚をどうぞ！'}</div>`;
    observePhotos();
  }

  // 画面に入ったカードの写真だけ、まとめて取りにいく
  let io, queue = new Set(), qTimer = null, inflight = new Set();
  function observePhotos() {
    if (io) io.disconnect();
    io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        const e = en.target.dataset.email;
        io.unobserve(en.target);
        if (!S.photos[e] && !inflight.has(e)) queue.add(e);
      });
      if (queue.size && !qTimer) qTimer = setTimeout(flushPhotos, 120);
    }, { rootMargin: '400px 0px' });
    $$('#mz-grid .mz-card').forEach(el => { if (!S.photos[el.dataset.email]) io.observe(el); });
  }
  async function flushPhotos() {
    qTimer = null;
    const batch = [...queue].slice(0, 20);
    batch.forEach(e => { queue.delete(e); inflight.add(e); });
    if (queue.size) qTimer = setTimeout(flushPhotos, 50);
    try {
      const d = await api('photos', { emails: batch });
      if (d.ok) Object.entries(d.photos).forEach(([e, ph]) => { S.photos[e] = ph; paintPhotos(e); });
    } catch (e) { /* 次に表示されたときに再挑戦 */ }
    batch.forEach(e => inflight.delete(e));
  }
  function paintPhotos(email) {
    const ph = S.photos[email];
    if (V && V.list[V.i].email === email) V.draw();
    $$(`#mz-grid .mz-card[data-email="${CSS.escape(email)}"]`).forEach(el => {
      if (ph.trail) el.querySelector('.photo').firstElementChild.outerHTML = `<img src="${esc(ph.trail)}" alt="">`;
      if (ph.face) el.querySelector('.mug').innerHTML = `<img src="${esc(ph.face)}" alt="">`;
    });
  }

  // ---------- 大きく見る（タップで裏返し・左右で前後の人へ） ----------
  let V = null;
  function openViewer(email, all) {
    const list = (all ? S.cards.slice() : S.cards.filter(matches)).sort(byTeam);
    let i = list.findIndex(c => c.email === email);
    if (i < 0) return;
    closeViewer();
    const el = document.createElement('div');
    el.className = 'mz-viewer'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
    root.appendChild(el);
    document.body.style.overflow = 'hidden';
    V = { el, list, i, flipped: false };
    // 大会予定などのシートから開いたときは、その上に重ねる（閉じればシートに戻る）
    if (document.querySelector('.mz-sheet')) el.style.zIndex = 70;
    const draw = () => {
      const c = V.list[V.i];
      el.setAttribute('aria-label', c.name + 'のカード');
      el.innerHTML = `<button class="close" id="v-close">閉じる ✕</button>
        <div class="stage">${cardHTML(c, S.photos[c.email], { flipped: V.flipped, docs: true })}</div>
        ${entriesOf(c.email).length ? `<button type="button" class="libl" id="v-entries">${esc(honor(c.nick || c.name))}の出場予定・結果（${entriesOf(c.email).length}件）</button>` : ''}
        <a class="libl" href="https://go-trail.net/pages/milers-training?member=${encodeURIComponent(c.email)}">${esc(honor(c.nick || c.name))}の練習記録を見る</a>
        ${((S.docsByEmail || {})[c.email] || []).length ? `<a class="libl" href="${LIB_URL}?by=${encodeURIComponent(c.email)}">レース資料庫で${esc(honor(c.nick || c.name))}の資料を見る（${S.docsByEmail[c.email].length}件）</a>` : ''}
        <div class="nav"><button id="v-prev" aria-label="前の人"${V.i === 0 ? ' disabled' : ''}>‹</button><span>${V.i + 1} / ${V.list.length}</span><button id="v-next" aria-label="次の人"${V.i === V.list.length - 1 ? ' disabled' : ''}>›</button></div>
        <div class="tip">カードをタップで裏返し</div>`;
      $('#v-close', el).onclick = closeViewer;
      if ($('#v-entries', el)) $('#v-entries', el).onclick = () => { el.style.zIndex = ''; openPersonEntries(c); };
      $('#v-prev', el).onclick = () => go(-1);
      $('#v-next', el).onclick = () => go(1);
      $('.mz-card', el).onclick = e => { if (e.target.closest('a')) return; const tip = e.target.closest('[data-tip]'); if (tip) { toast(tip.dataset.tip); return; } if (e.target.closest('.next')) { el.style.zIndex = ''; openPersonEntries(c); return; } V.flipped = !V.flipped; $('.mz-card', el).classList.toggle('flipped'); };
      if (!S.photos[c.email]) { queue.add(c.email); if (!qTimer) qTimer = setTimeout(flushPhotos, 0); }
    };
    const go = d => { const n = V.i + d; if (n < 0 || n >= V.list.length) return; V.i = n; V.flipped = false; draw(); };
    V.draw = draw; V.go = go;
    el.addEventListener('click', e => { if (e.target === el) closeViewer(); });
    let sx = null;
    el.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', e => { if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1); });
    draw();
  }
  function closeViewer() { if (V) { V.el.remove(); V = null; if (!E && !document.querySelector('.mz-sheet')) document.body.style.overflow = ''; } }

  // ---------- 画像の縮小 ----------
  async function loadImage(file) {
    try { return await createImageBitmap(file, { imageOrientation: 'from-image' }); }
    catch (e) {
      return await new Promise((ok, ng) => { const img = new Image(); img.onload = () => ok(img); img.onerror = () => ng(new Error('decode')); img.src = URL.createObjectURL(file); });
    }
  }
  // カードの枠に合わせて中央を切り抜き、文字数の上限に収まるまで画質を下げる
  // 細かい写真はSafariだと最低画質でも収まらないので、そのときは写真を少しずつ小さくしてやり直す（2026-10-28）
  async function toCardJpeg(file, [w, h], maxChars) {
    const img = await loadImage(file);
    const iw = img.width, ih = img.height;
    const scale = Math.max(w / iw, h / ih);
    const sw = w / scale, sh = h / scale;
    for (const k of [1, 0.9, 0.8, 0.7, 0.6, 0.5]) {
      const cw = Math.round(w * k), ch = Math.round(h * k);
      const c = document.createElement('canvas'); c.width = cw; c.height = ch;
      const ctx = c.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, (iw - sw) / 2, (ih - sh) / 2, sw, sh, 0, 0, cw, ch);
      for (let q = k === 1 ? 0.85 : 0.6; q >= 0.3; q -= 0.07) {
        const d = c.toDataURL('image/jpeg', q);
        if (d.length <= maxChars) return d;
      }
    }
    throw new Error('too_large');
  }

  // ---------- 編集画面 ----------
  let E = null; // 編集中の状態

  async function openEditor(target, preset, opts) {
    loadDbRaces();
    const wrap = document.createElement('div');
    wrap.className = 'mz-editor';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', 'カードの編集');
    wrap.innerHTML = `<div class="bar"><b>カードの編集</b><button class="mz-btn ghost" id="e-close">閉じる</button></div><div class="body"><div class="mz-loading">読み込んでいます…</div></div>`;
    root.appendChild(wrap);
    document.body.style.overflow = 'hidden';
    $('#e-close', wrap).onclick = closeEditor;
    let prof = preset;
    let members = null;
    try {
      if (!prof) {
        const d = target === S.me.email ? await api('me') : await api('profile', { target });
        if (!d.ok) throw new Error(d.reason);
        prof = d.profile;
        if (d.races) S.races = d.races;
      }
      if (S.me.admin) { const m = await api('members'); if (m.ok) members = m.members; }
    } catch (e) { if (e.message !== 'auth') { toast('読み込めませんでした'); closeEditor(); } return; }
    const rosterNo = (members || []).find(m => m.email === target);
    E = {
      target, members, wrap,
      p: Object.assign({ email: target, name: '', roman: '', nick: '', pref: '', city: '', since: '', pos: '', tags: [], goal: '', comment: '', races: [], pcTitle: '', pcAbout: '', pcStandfm: '', pcSpotify: '', pcVoicy: '', pcYoutube: '', pcPublic: false, pcMain: '' }, prof || {}),
      face: prof && prof.face || '', trail: prof && prof.trail || '',
      faceChanged: false, trailChanged: false,
      consented: !!(prof && prof.consentAt), isNew: !prof,
    };
    E.p.no = (S.cards.find(c => c.email === target) || {}).no || (rosterNo && rosterNo.no) || (target === S.me.email ? S.me.no : 0);
    const rsrc = target === S.me.email ? S.me : (rosterNo || {});
    if (!E.p.teams) E.p.teams = rsrc.teams || [];
    if (!E.p.roles) E.p.roles = rsrc.roles || [];
    E.customPos = !!E.p.pos && !POSITIONS.includes(E.p.pos);
    E.p.races = (E.p.races || []).map(r => Object.assign({}, r));
    E.origRaceNames = new Set(E.p.races.map(r => normR(r.race)));
    if (!E.p.races.length) E.p.races.push(blankRace());
    renderEditor();
  }
  function closeEditor() { if (E && E.wrap) E.wrap.remove(); else $$('.mz-editor').forEach(x => x.remove()); E = null; document.body.style.overflow = ''; }
  const HAND_MAX = 60; // 手で入れる戦績の上限（データ側と同じ）
  function blankRace() { return { race: '', ov: false, ym: '', km: '', time: '', _other: false }; }

  function renderEditor() {
    const p = E.p;
    const raceNames = S.races.map(r => r.name);
    const years = []; for (let y = today().getFullYear(); y >= 1990; y--) years.push(y);
    const body = $('.body', E.wrap);
    body.innerHTML = `
      <div class="cols">
        <form class="mz-form" id="e-form" novalidate>
          ${E.target === S.me.email ? `<div class="mz-sec mz-goentry"><div><b>出る大会・結果を入れるときは</b><span>名鑑の一番上「あなたの大会」で入れます（この画面は写真・名前などを変える所です）</span></div><button type="button" class="mz-btn" data-goentry="">大会の予定・結果へ</button></div>` : ''}
          ${E.members ? `<div class="mz-sec"><h3>管理者メニュー</h3>
            <label class="mz-field"><span>編集するメンバー</span><select id="e-target">${E.members.map(m => `<option value="${esc(m.email)}"${m.email === E.target ? ' selected' : ''}>No.${String(m.no).padStart(3, '0')} ${esc(m.name)}（${esc(m.email)}）</option>`).join('')}</select></label></div>` : ''}

          <div class="mz-sec"><h3>写真</h3>
            <p class="hint">カードの枠に合わせて、写真の中央が切り抜かれます。顔写真は顔がはっきり写ったもの、トレイル写真は大会のオフィシャル写真でもOKです。</p>
            <div class="mz-photos">
              ${photoField('trail', 'トレイルで走っている写真（表面）', E.trail)}
              ${photoField('face', '顔写真（裏面）', E.face)}
            </div>
          </div>

          <div class="mz-sec"><h3>基本情報</h3>
            <div class="mz-2col">
              ${textField('name', '名前（フルネーム）', 30, true, '例：山本 健太')}
              ${textField('nick', '呼び名・ニックネーム', 20, true, '例：ケンタ（みんなに呼ばれている名前）')}
            </div>
            ${textField('roman', '名前のローマ字', 40, true, '例：YAMAMOTO KENTA')}
            <div class="mz-2col">
              <label class="mz-field"><span>都道府県<em>必須</em></span><select name="pref"><option value="">選んでください</option>${PREFS.map(v => `<option${v === p.pref ? ' selected' : ''}>${v}</option>`).join('')}</select></label>
              ${textField('city', '市区町村', 20, false, '例：豊田市（任意）')}
            </div>
            <label class="mz-field"><span>トレランを始めた年<em>必須</em></span><select name="since"><option value="">選んでください</option>${years.map(y => `<option${String(y) === String(p.since) ? ' selected' : ''}>${y}</option>`).join('')}</select></label>
          </div>

          <div class="mz-sec"><h3>ポジションと得意なこと</h3>
            <label class="mz-field"><span>ポジション（カード表面の赤いラベル）<em>必須</em></span><select id="e-possel"><option value="">選んでください</option>${POSITIONS.map(v => `<option${v === p.pos ? ' selected' : ''}>${v}</option>`).join('')}<option value="${OTHER}"${E.customPos ? ' selected' : ''}>自分で書く（${POS_MAX}文字まで）</option></select></label>
            <label class="mz-field" id="e-poswrap"${E.customPos ? '' : ' hidden'}><span>自分だけのポジション</span><input id="e-posin" maxlength="${POS_MAX}" value="${E.customPos ? esc(p.pos) : ''}" placeholder="例：関門ギリギリ職人" autocomplete="off"></label>
            <div class="mz-field"><span>得意なこと（${MAX_TAGS}つまで・絞り込みに使われます）</span>
              ${TAG_GROUPS.map(([g, tags]) => `<div class="mz-chipgroup">${esc(g)}</div><div class="mz-chips">${tags.map(t => `<button type="button" class="mz-chip" data-tag="${esc(t)}" aria-pressed="${p.tags.includes(t)}">${esc(t)}</button>`).join('')}</div>`).join('')}
            </div>
          </div>

          <div class="mz-sec"><h3>戦績（完走したレース）</h3>
            ${p.racesBroken ? '<div class="mz-errors" role="alert">手で入れた戦績のデータに不具合があり、読み込めませんでした。運営が直すまで、このカードは保存できません。運営に知らせてください。</div>' : ''}
            <p class="hint">代表的なレースから入れてください。1レース以上必須、あとからいくつでも追加できます。100マイル（160km以上）の完走でランクが上がります。</p>
            <div id="e-races" style="display:flex;flex-direction:column;gap:10px">${p.races.map((r, i) => raceRow(r, i, raceNames, years)).join('')}</div>
            <button type="button" class="mz-add" id="e-addrace">＋ レースを追加</button>
          </div>

          <div class="mz-sec"><h3>目標とひとこと</h3>
            ${textField('goal', '次の目標レース', 60, false, '例：UTMB（2027）')}
            <label class="mz-field"><span>ひとこと<em>必須</em></span><textarea name="comment" maxlength="80" placeholder="例：登りは任せてください。海外レースの準備、なんでも聞いてください！">${esc(p.comment)}</textarea><span class="cnt" id="e-cnt"></span></label>
          </div>

          <div class="mz-sec"><h3>ポッドキャスト・音声配信（任意）</h3>
            <p class="hint">番組をやっている人だけ入れてください。カードの裏に番組名とリンクが出ます。配信しているところのURLだけでOKです（全部でなくて大丈夫）。</p>
            ${textField('pcTitle', '番組名', 40, false, '例：ケンタの100マイルラジオ')}
            <label class="mz-field"><span>番組の紹介（100文字まで）</span><textarea name="pcAbout" maxlength="100" placeholder="例：毎週月曜配信。レースの振り返りと練習の話をゆるく話しています。">${esc(p.pcAbout)}</textarea></label>
            <div class="mz-2col">${PODCASTS.map(x => `<label class="mz-field"><span>${x.label}のURL</span><input name="${x.key}" type="url" inputmode="url" maxlength="300" value="${esc(p[x.key])}" placeholder="${esc(x.ph)}" autocomplete="off"></label>`).join('')}</div>
            <div id="e-pcmain">${pcMainField()}</div>
            <label class="mz-consent"><input type="checkbox" name="pcPublic"${p.pcPublic ? ' checked' : ''}><span>マイラーズの<a href="${PODCAST_PAGE}" target="_blank" rel="noopener">ポッドキャスト紹介ページ</a>（誰でも見られる公開ページ）に番組を載せる。載るのは<b>番組名・紹介・呼び名・所属チーム・番組のリンク</b>だけで、写真・本名・戦績は出ません。</span></label>
          </div>

          ${E.consented ? '' : `<div class="mz-sec"><label class="mz-consent"><input type="checkbox" id="e-consent"><span>名鑑への掲載に同意します。名鑑の内容（写真・名前・戦績など）はマイラーズの外に出しません。</span></label></div>`}

          <div id="e-errors"></div>
          <div class="mz-actions">
            <button type="button" class="mz-btn ghost" id="e-history" style="color:var(--navy)"${E.isNew ? ' hidden' : ''}>前の状態に戻す</button>
            <button type="submit" class="mz-btn" id="e-save">保存する</button>
          </div>
          <div id="e-histbox"></div>
        </form>
        <aside class="preview"><div id="e-preview"></div><p>タップで裏返ります</p></aside>
      </div>`;
    bindEditor();
    updatePreview();
  }

  // 最新話の一覧をどのサービスから出すか（URLが2つ以上のときだけ選ぶ。初期値はSpotify）
  const PC_NAMES = { pcStandfm: 'standfm', pcSpotify: 'spotify', pcVoicy: 'voicy', pcYoutube: 'youtube' };
  function pcMainField() {
    const have = PODCASTS.filter(x => E.p[x.key] && x.re.test(E.p[x.key]));
    if (have.length < 2) return '';
    const cur = have.some(x => PC_NAMES[x.key] === E.p.pcMain) ? E.p.pcMain : (have.find(x => x.key === 'pcSpotify') ? 'spotify' : PC_NAMES[have[0].key]);
    return `<label class="mz-field"><span>公開ページの「最新5話」をどのサービスから出すか</span><select name="pcMain">${have.map(x => `<option value="${PC_NAMES[x.key]}"${PC_NAMES[x.key] === cur ? ' selected' : ''}>${x.label}${x.key === 'pcVoicy' ? '（Voicyは最新話の一覧を出せません）' : ''}</option>`).join('')}</select></label>`;
  }
  function textField(name, label, max, req, ph) {
    return `<label class="mz-field"><span>${label}${req ? '<em>必須</em>' : ''}</span><input name="${name}" maxlength="${max}" value="${esc(E.p[name])}" placeholder="${esc(ph || '')}" autocomplete="off"></label>`;
  }
  function photoField(kind, label, src) {
    return `<div class="mz-photo">
      <div class="pv${src ? ' set' : ''}" id="pv-${kind}" style="${src ? `background-image:url('${esc(src)}')` : ''}">${label}</div>
      <label for="in-${kind}">${src ? '写真を変える' : '写真を選ぶ'}</label>
      <input type="file" accept="image/*" id="in-${kind}" data-kind="${kind}">
    </div>`;
  }
  function raceRow(r, i, raceNames, years) {
    // 「出場予定・結果」の完走から自動で入った行は、ここでは直せない（直すときは向こうのタブで）
    if (r.eid) return `<div class="mz-race auto" data-i="${i}"><div class="full"><b>${esc(dispName(r.race))}</b>　${esc(r.ym)}　${esc(r.km)}km　${esc(r.time)}</div>
      <p class="mz-ovnote full">名鑑の一番上「あなたの大会」で入れた完走から、自動で入った記録です。直すとき・消すときは <button type="button" class="mz-linkbtn" data-goentry="${esc(r.eid)}">あなたの大会</button> で行います。</p></div>`;
    const [ry, rm] = r.ym ? r.ym.split('.') : ['', ''];
    const known = r.race ? findRace(r.race) : null;
    const cats = known && (known.cats || []).length ? `<div class="mz-cats full"><span>種目を選ぶと距離が入ります</span>${known.cats.map(c => `<button type="button" class="mz-chip" data-km="${esc(c.km)}" aria-pressed="${Number(r.km) === c.km}">${esc(c.label)}${c.label.includes(String(c.km)) ? '' : `（${esc(c.km)}km）`}</button>`).join('')}</div>` : '';
    const ovPart = !r.race ? ''
      : known && !known.pending ? `<p class="mz-ovnote full">${known.ov ? '海外' : '国内'}のレース（自動で判定）${known.db ? '・ランクへの反映は運営が確認してからになります' : known.itra ? '' : '・ITRAに登録されていないため、ランクには数えません'}</p>${cats}`
      : known ? `<p class="mz-ovnote full">運営が確認中のレースです</p>`
      : !DB_READY ? `<p class="mz-ovnote full">一覧を読み込んでいます…</p>`
      : `<p class="mz-ovnote full mz-warn">「${esc(r.race)}」は一覧にありません。候補から選んでください。見つからないときは <button type="button" class="mz-linkbtn" data-req="${esc(r.race)}">運営に追加を頼む</button></p>`;
    const twin = r.race && r.ym ? E.p.races.find(x => x.eid && x.ym === r.ym && normR(canonName(x.race)) === normR(canonName(r.race)) && Math.abs((Number(x.km) || 0) - (Number(r.km) || 0)) <= Math.max(1, (Number(x.km) || 0) * 0.1)) : null;
    return `<div class="mz-race" data-i="${i}">
      <button type="button" class="del" data-del="${i}" aria-label="このレースを消す">✕ 消す</button>
      ${twin ? `<p class="mz-ovnote full mz-warn">「あなたの大会」で入れた完走（${esc(twin.ym)} ${esc(twin.km)}km ${esc(twin.time)}）と同じ記録かもしれません。同じなら、この行を「✕ 消す」で消してください（別の記録ならそのままで大丈夫です）。</p>` : ''}
      <div class="mz-field full"><label for="rq-${i}"><span>レース名（打つと候補が出ます）</span></label>
        <div class="mz-combo"><input id="rq-${i}" data-f="raceq" maxlength="60" value="${esc(r.race ? dispName(r.race) : '')}" placeholder="例：びわ、UTMB、信越" autocomplete="off" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="rs-${i}">
        <div class="mz-sugg" id="rs-${i}" role="listbox" hidden></div></div></div>
      ${ovPart}
      <label class="mz-field third"><span>年</span><select data-f="y"><option value="">年</option>${years.map(y => `<option${String(y) === ry ? ' selected' : ''}>${y}</option>`).join('')}</select></label>
      <label class="mz-field third"><span>月</span><select data-f="m"><option value="">月</option>${Array.from({ length: 12 }, (_, k) => String(k + 1).padStart(2, '0')).map(m => `<option value="${m}"${m === rm ? ' selected' : ''}>${Number(m)}月</option>`).join('')}</select></label>
      <label class="mz-field third"><span>距離（km）</span><input data-f="km" type="number" inputmode="decimal" min="1" max="1000" value="${esc(r.km)}"></label>
      <label class="mz-field full"><span>記録（任意）</span><input data-f="time" maxlength="12" placeholder="例：27:50" value="${esc(r.time)}"></label>
    </div>`;
  }

  // 候補の表示と選択
  function showSugg(row, q) {
    const box = $('.mz-sugg', row), inp = $('[data-f=raceq]', row);
    const list = suggestRaces(q);
    if (!q.trim()) { box.hidden = true; inp.setAttribute('aria-expanded', 'false'); return; }
    const exact = list.length && normR(list[0].name) === normR(q);
    box.innerHTML = list.map((r, k) => `<button type="button" role="option" data-pick="${esc(r.name)}" data-k="${k}">${esc(r.short || r.name)}${r.short ? `<span class="sub">${esc(r.name)}</span>` : ''}<small>${r.ov ? '海外' : '国内'}${r.db ? '' : r.pending ? '・確認中' : r.itra ? '' : '・ITRA外'}</small></button>`).join('')
      + (exact ? '' : `<button type="button" role="option" data-req="${esc(q.trim())}" class="new">見つからないときは → 運営に追加を頼む</button>`);
    box.hidden = false; inp.setAttribute('aria-expanded', 'true');
  }
  function pickRace(row, name, isNew) {
    const r = E.p.races[Number(row.dataset.i)];
    if (isNew) { r.race = $('[data-f=raceq]', row).value.trim(); const k = findRace(r.race); r.ov = k ? k.ov : null; }
    else { const k = findRace(name); r.race = k ? k.name : name; r.ov = k ? k.ov : null; if (k && (k.cats || []).length === 1 && !r.km) r.km = k.cats[0].km; }
    rerenderRaces(); updatePreview();
    const next = $(`.mz-race[data-i="${row.dataset.i}"] [data-f=y]`, E.wrap); if (next) next.focus();
  }

  function bindEditor() {
    const form = $('#e-form', E.wrap);
    if ($('#e-target', E.wrap)) $('#e-target', E.wrap).onchange = e => { const t = e.target.value; closeEditor(); openEditor(t); };
    const ge = $('.mz-goentry [data-goentry]', form);
    if (ge) ge.onclick = () => goEntry(null);
    form.addEventListener('input', onFormInput);
    form.addEventListener('change', onFormInput);
    $$('.mz-chip', form).forEach(b => b.onclick = () => {
      const t = b.dataset.tag, on = E.p.tags.includes(t);
      if (!on && E.p.tags.length >= MAX_TAGS) return toast(`得意なことは${MAX_TAGS}つまでです`);
      E.p.tags = on ? E.p.tags.filter(x => x !== t) : E.p.tags.concat(t);
      b.setAttribute('aria-pressed', String(!on));
      updatePreview();
    });
    $$('input[type=file]', form).forEach(inp => inp.onchange = onPhoto);
    $('#e-addrace', form).onclick = () => {
      if (E.p.races.filter(r => !r.eid).length >= HAND_MAX) return toast(`手で入れる戦績は${HAND_MAX}件までです`);
      E.p.races.push(blankRace()); rerenderRaces();
    };
    $('#e-races', form).addEventListener('mousedown', e => { if (e.target.closest('.mz-sugg button')) e.preventDefault(); });
    $('#e-races', form).addEventListener('click', e => {
      const ck = e.target.closest('[data-km]');
      if (ck) { const row = ck.closest('.mz-race'); E.p.races[Number(row.dataset.i)].km = Number(ck.dataset.km); rerenderRaces(); updatePreview(); return; }
      const go = e.target.closest('[data-goentry]');
      if (go) { goEntry(go.dataset.goentry); return; }
      const rq = e.target.closest('[data-req]');
      if (rq) { const row = rq.closest('.mz-race'); $('.mz-sugg', row).hidden = true; openRaceRequest(rq.dataset.req, name => pickRace(row, name, false)); return; }
      const pk = e.target.closest('.mz-sugg button');
      if (pk) { pickRace(pk.closest('.mz-race'), pk.dataset.pick, false); return; }
    });
    $('#e-races', form).addEventListener('keydown', e => {
      const box = e.target.closest('.mz-race') && $('.mz-sugg', e.target.closest('.mz-race'));
      if (!box || box.hidden) return;
      const items = $$('button', box), cur = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[cur + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[cur - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Escape') { box.hidden = true; }
    });
    $('#e-races', form).addEventListener('click', e => {
      const d = e.target.closest('[data-del]'); if (!d) return;
      E.p.races.splice(Number(d.dataset.del), 1);
      if (!E.p.races.length) E.p.races.push(blankRace());
      rerenderRaces(); updatePreview();
    });
    form.onsubmit = e => { e.preventDefault(); save(); };
    $('#e-history', form).onclick = showHistory;
    $('#e-preview', E.wrap).onclick = e => { const c = e.target.closest('.mz-card'); if (c) { E.flipped = !E.flipped; c.classList.toggle('flipped'); } };
  }

  function rerenderRaces() {
    const years = []; for (let y = today().getFullYear(); y >= 1990; y--) years.push(y);
    $('#e-races', E.wrap).innerHTML = E.p.races.map((r, i) => raceRow(r, i, S.races.map(x => x.name), years)).join('');
  }

  function onFormInput(e) {
    if (!E) return; // 管理者が編集するメンバーを切り替えた直後（編集画面を閉じたあと）に届いた入力は無視する
    const t = e.target;
    const row = t.closest('.mz-race');
    if (row) {
      const r = E.p.races[Number(row.dataset.i)], f = t.dataset.f;
      if (f === 'raceq') {
        if (e.type === 'input') { r.race = t.value.trim(); const k = findRace(r.race); r.ov = k ? k.ov : null; showSugg(row, t.value); }
        else if (e.type === 'change') {
          // 候補を選ばずに入力欄を離れたとき：一覧と同じ名前なら正式名に、なければ新しいレースとして国内／海外を聞く
          setTimeout(() => { if (document.activeElement && row.contains(document.activeElement) && document.activeElement.closest('.mz-sugg')) return; if (findRace(t.value)) pickRace(row, t.value, false); else { $('.mz-sugg', row).hidden = true; rerenderRaces(); } }, 150);
        }
      } else if (f === 'ov') r.ov = t.value === '' ? null : t.value === '1';
      else if (f === 'y' || f === 'm') {
        const y = $('[data-f=y]', row).value, m = $('[data-f=m]', row).value;
        r.ym = y && m ? `${y}.${m}` : '';
      } else if (f === 'km') r.km = t.value === '' ? '' : Number(t.value);
      else if (f === 'time') r.time = t.value.trim();
    } else if (t.id === 'e-possel') {
      E.customPos = t.value === OTHER;
      $('#e-poswrap', E.wrap).hidden = !E.customPos;
      E.p.pos = E.customPos ? $('#e-posin', E.wrap).value.trim() : t.value;
      if (E.customPos && e.type === 'change') $('#e-posin', E.wrap).focus();
    } else if (t.id === 'e-posin') {
      E.p.pos = t.value.trim();
    } else if (t.name === 'pcPublic') {
      E.p.pcPublic = t.checked;
    } else if (t.name) {
      E.p[t.name] = t.name.startsWith('pc') && t.name !== 'pcTitle' && t.name !== 'pcAbout' ? t.value.trim() : t.value;
      if (PC_NAMES[t.name] && e.type === 'change') { const box = $('#e-pcmain', E.wrap); if (box) box.innerHTML = pcMainField(); }
    }
    const cnt = $('#e-cnt', E.wrap); if (cnt) cnt.textContent = `${(E.p.comment || '').length} / 80`;
    updatePreview();
  }

  async function onPhoto(e) {
    const file = e.target.files && e.target.files[0]; if (!file) return;
    const kind = e.target.dataset.kind;
    const pv = $('#pv-' + kind, E.wrap);
    pv.classList.remove('set'); pv.textContent = '写真を準備しています…';
    try {
      const d = kind === 'trail' ? await toCardJpeg(file, TRAIL_SIZE, TRAIL_MAX) : await toCardJpeg(file, FACE_SIZE, FACE_MAX);
      E[kind] = d; E[kind + 'Changed'] = true;
      pv.style.backgroundImage = `url('${d}')`; pv.classList.add('set'); pv.textContent = '';
      e.target.previousElementSibling.textContent = '写真を変える';
      updatePreview();
    } catch (err) {
      pv.textContent = err.message === 'too_large' ? 'この写真は細かすぎて、カードに収まりませんでした。別の写真を選んでください。' : 'この写真は読み込めませんでした。別の写真（JPEGやPNG）を選んでください。';
    }
    e.target.value = '';
  }

  function cleanRaces() {
    return E.p.races.filter(r => r.race || r.ym || r.km).map(r => Object.assign({ race: r.race, ov: r.ov == null ? null : !!r.ov, ym: r.ym, km: Number(r.km) || 0, time: r.time || '' }, r.eid ? { eid: r.eid } : {}));
  }
  function updatePreview() {
    const p = Object.assign({}, E.p, { races: cleanRaces().filter(r => r.race && r.ym && r.km) });
    $('#e-preview', E.wrap).innerHTML = cardHTML(p, { face: E.face, trail: E.trail }, { flipped: E.flipped });
  }

  function validate() {
    const p = E.p, errs = [];
    if (!E.trail) errs.push('トレイルで走っている写真を選んでください');
    if (!E.face) errs.push('顔写真を選んでください');
    if (!p.name.trim()) errs.push('名前を入れてください');
    if (!p.nick.trim()) errs.push('呼び名を入れてください');
    if (!p.roman.trim()) errs.push('名前のローマ字を入れてください');
    if (!p.pref) errs.push('都道府県を選んでください');
    if (!p.since) errs.push('トレランを始めた年を選んでください');
    if (!p.pos) errs.push(E.customPos ? '自分だけのポジションを書いてください' : 'ポジションを選んでください');
    if (!p.comment.trim()) errs.push('ひとことを入れてください');
    const rs = cleanRaces();
    // 番号は画面の並び（自動の行・空の行も含めて上から何番目か）にそろえる
    E.p.races.forEach((r0, i) => {
      if (r0.eid || !(r0.race || r0.ym || r0.km)) return;
      const r = { race: r0.race, ym: r0.ym, km: Number(r0.km) || 0 };
      if (!r.race || !r.ym || !r.km) errs.push(`戦績の上から${i + 1}つ目${r.race ? `（${dispName(r.race)}）` : ''}：レース・年・月・距離をすべて入れてください`);
      else if (DB_READY && !findRace(r.race) && !(E.origRaceNames || new Set()).has(normR(r.race))) errs.push(`戦績の上から${i + 1}つ目：「${r.race}」は一覧にありません。候補から選ぶか、「運営に追加を頼む」を押してください`);
    });
    if (!rs.length) errs.push('戦績を1レース以上入れてください');
    if (rs.filter(r => !r.eid).length > HAND_MAX) errs.push(`手で入れる戦績は${HAND_MAX}件までです（いま${rs.filter(r => !r.eid).length}件）`);
    PODCASTS.forEach(x => { if (p[x.key] && !x.re.test(p[x.key])) errs.push(`${x.label}のURLを確かめてください（${x.ph.replace('…', '')} で始まるURL）`); });
    const anyUrl = PODCASTS.some(x => p[x.key]);
    if (anyUrl && !p.pcTitle.trim()) errs.push('ポッドキャストの番組名を入れてください');
    if (!anyUrl && p.pcTitle.trim()) errs.push('ポッドキャストのURLを1つ以上入れてください');
    if (!E.consented && !($('#e-consent', E.wrap) || {}).checked) errs.push('掲載への同意にチェックを入れてください');
    return errs;
  }

  async function save() {
    const errs = validate();
    const box = $('#e-errors', E.wrap);
    if (errs.length) {
      box.innerHTML = `<div class="mz-errors" role="alert"><b>保存の前に確認してください</b><ul>${errs.map(x => `<li>${esc(x)}</li>`).join('')}</ul></div>`;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    box.innerHTML = '';
    const btn = $('#e-save', E.wrap); btn.disabled = true; btn.textContent = '保存しています…';
    const p = E.p;
    const payload = {
      target: E.target, rev: p.rev || 0,
      profile: { name: p.name, roman: p.roman, nick: p.nick, pref: p.pref, city: p.city, since: p.since, pos: p.pos, tags: p.tags, goal: p.goal, comment: p.comment, races: cleanRaces(), consent: true,
        pcTitle: p.pcTitle.trim(), pcAbout: p.pcAbout.trim(), pcStandfm: p.pcStandfm, pcSpotify: p.pcSpotify, pcVoicy: p.pcVoicy, pcYoutube: p.pcYoutube, pcPublic: !!p.pcPublic,
        pcMain: (($('[name=pcMain]', E.wrap) || {}).value) || '' },
    };
    if (E.faceChanged) payload.face = E.face;
    if (E.trailChanged) payload.trail = E.trail;
    try {
      const d = await api('save', payload);
      if (!d.ok && d.reason === 'conflict') {
        btn.disabled = false; btn.textContent = '保存する';
        box.innerHTML = `<div class="mz-errors" role="alert">別の画面（ほかのタブやスマホ）で、先にこのカードが保存されています。この画面の内容で上書きすると、そちらの変更が消えてしまうため止めました。<br>この画面で入れた内容は残っています。必要ならメモしてから、最新の内容を読み込んでください。<br><button type="button" class="mz-btn" id="e-reload" style="margin-top:8px">最新の内容を読み込む（この画面の変更は消えます）</button></div>`;
        $('#e-reload', box).onclick = () => { const t = E.target; closeEditor(); openEditor(t); };
        return;
      }
      if (!d.ok && d.reason === 'races_broken') { btn.disabled = false; btn.textContent = '保存する'; box.innerHTML = '<div class="mz-errors" role="alert">戦績のデータに不具合があるため、保存を止めました（入力した内容は消えていません）。運営に「戦績が保存できない」と知らせてください。</div>'; return; }
      if (!d.ok && d.reason === 'too_many_races') { btn.disabled = false; btn.textContent = '保存する'; box.innerHTML = `<div class="mz-errors" role="alert">手で入れる戦績は${HAND_MAX}件までです。</div>`; return; }
      if (!d.ok && d.reason === 'race_catalog_unavailable') { btn.disabled = false; btn.textContent = '保存する'; box.innerHTML = '<div class="mz-errors" role="alert">大会の一覧を読み込めませんでした。少し時間をおいて、もう一度保存してください。</div>'; return; }
      if (!d.ok && d.reason === 'unknown_race') {
        btn.disabled = false; btn.textContent = '保存する';
        box.innerHTML = `<div class="mz-errors" role="alert">戦績のレース「${esc((d.races || []).join('」「'))}」が一覧にありません。候補から選ぶか、「運営に追加を頼む」を押してください。</div>`;
        return;
      }
      if (!d.ok) throw new Error(d.reason);
      S.photos[E.target] = { face: E.face, trail: E.trail };
      toast('保存しました');
      closeEditor();
      await reloadList();
    } catch (e) {
      if (e.message === 'auth') return;
      btn.disabled = false; btn.textContent = '保存する';
      box.innerHTML = `<div class="mz-errors" role="alert">保存できませんでした（${esc(e.message)}）。電波の良いところでもう一度お試しください。</div>`;
    }
  }

  async function reloadList() {
    const d = await api('list');
    if (!d.ok) return;
    closeViewer();
    S.cards = d.cards; S.entries = d.entries || []; S.races = d.races; S.rosterCount = d.rosterCount; S.pendingCount = d.pendingCount || 0; S.pendingRaces = d.pendingRaces || 0; S.weeklyNotice = d.weeklyNotice || null; S.reactNotice = d.reactNotice || null; S.ideaCount = d.ideaCount || 0;
    S.myProfile = S.cards.find(c => c.email === S.me.email) || null;
    renderApp();
  }

  async function showHistory() {
    const box = $('#e-histbox', E.wrap);
    box.innerHTML = '<div class="mz-sec"><div class="mz-loading" style="padding:16px">読み込んでいます…</div></div>';
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    let d;
    try { d = await api('history', { target: E.target }); } catch (e) { return; }
    if (!d.ok || !d.items.length) { box.innerHTML = '<div class="mz-sec"><p class="hint">戻せる状態はまだありません（保存するたびに、保存する前の状態が残ります）。</p></div>'; return; }
    box.innerHTML = `<div class="mz-sec"><h3>前の状態に戻す</h3>
      <p class="hint">保存する前の状態が、新しい順に${d.items.length}つ残っています。選ぶと右（スマホでは上）のカードで中身を確かめられます。</p>
      <div class="mz-history">${d.items.map((h, i) => `<button type="button" class="item" data-h="${i}" aria-pressed="false"><span>${fmtDate(h.at)} の保存より前</span><small>${h.by === E.target ? '本人' : '管理者'}</small></button>`).join('')}</div>
      <div class="mz-actions" style="padding:0"><button type="button" class="mz-btn ghost" id="h-cancel" style="color:var(--navy)">やめる</button><button type="button" class="mz-btn" id="h-restore" disabled>この状態に戻す</button></div></div>`;
    let pick = null;
    $$('.item', box).forEach(b => b.onclick = () => {
      $$('.item', box).forEach(x => x.setAttribute('aria-pressed', 'false'));
      b.setAttribute('aria-pressed', 'true');
      pick = d.items[Number(b.dataset.h)];
      $('#e-preview', E.wrap).innerHTML = cardHTML(Object.assign({ no: E.p.no }, pick.profile), { face: pick.profile.face, trail: pick.profile.trail });
      $('#h-restore', box).disabled = false;
    });
    $('#h-cancel', box).onclick = () => { box.innerHTML = ''; updatePreview(); };
    $('#h-restore', box).onclick = async () => {
      if (!pick) return;
      const btn = $('#h-restore', box); btn.disabled = true; btn.textContent = '戻しています…';
      try {
        const r = await api('restore', { target: E.target, id: pick.id });
        if (!r.ok) throw new Error(r.reason);
        S.photos[E.target] = { face: pick.profile.face, trail: pick.profile.trail };
        toast('前の状態に戻しました');
        closeEditor(); await reloadList();
      } catch (e) { if (e.message !== 'auth') { btn.disabled = false; btn.textContent = 'この状態に戻す'; toast('戻せませんでした'); } }
    };
  }

  // ---------- 出場予定・結果（2026-10-16） ----------
  // 大会前：出る大会・種目・日付を登録 → カードに「次戦」、チームの「今週のレース予定」に載る
  // 大会後：完走（○時間○分）／DNF（やめた地点km）／DNS。完走はデータ側が戦績にも足す
  // チームの大会ページは毎週水曜で切り替え（今週＝その水曜を含む月〜日、先週＝その前の月〜日）
  const pad2 = n => String(n).padStart(2, '0');
  const ymd = d => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  // 「今日」は日本時間で決める（データ側と同じ。海外の端末でも週の区切りや結果の入力可否がずれないように）
  const JST_FMT = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' });
  const todayStr = () => JST_FMT.format(new Date());
  const jstToday = () => { const [y, m, d] = todayStr().split('-').map(Number); return new Date(y, m - 1, d); };
  const mdOf = s => { const [, m, d] = String(s).split('-').map(Number); return `${m}/${d}`; };
  const WD = ['日', '月', '火', '水', '木', '金', '土'];
  const mdw = s => { const [y, m, d] = String(s).split('-').map(Number); return `${m}/${d}（${WD[new Date(y, m - 1, d).getDay()]}）`; };
  const entriesOf = email => (S.entries || []).filter(e => e.email === email);
  const catOf = e => e.cat || (e.km + 'km');
  const timeOf = e => `${e.h}時間${pad2(e.m)}分`;
  const isStaff = () => !!S.me && (S.me.admin || (S.me.roles || []).some(r => ROLE_ORDER.includes(r)));
  // 本名（カードの名前、なければ名簿の名前）。「今週レースに出るメンバー」で誰か分かるように（2026-10-19）
  const fullNameOf = email => { const c = S.cards.find(x => x.email === email); const e = (S.entries || []).find(x => x.email === email); return String((c && c.name) || (e && e.fullName) || (e && e.name) || '').replace(/[\s　]+/g, ''); };
  // 一覧で呼ぶ名前。呼び名が「タカ、なかお」「まっすー/まっすん」のように複数あるときは最初の1つ
  const nameOf = email => { const c = S.cards.find(x => x.email === email); const e = (S.entries || []).find(x => x.email === email); const n = (c && (c.nick || c.name)) || (e && e.name) || ''; return n.split(/[、,，\/／]/)[0].trim() || n; };
  // 自分の「結果待ち」（大会の日を過ぎて、結果をまだ入れていないもの）
  const myPending = () => entriesOf(S.me.email).filter(e => !e.st && e.date < todayStr());
  // ※大会の終了日は持っていないので、複数日の大会は走っている途中（2日目以降）から「結果を入れてください」に出ることがある
  function nextEntry(email) {
    const t = todayStr();
    return entriesOf(email).filter(e => !e.st && e.date >= t).sort((a, b) => a.date.localeCompare(b.date))[0] || null;
  }
  function nextBadge(email) {
    const n = nextEntry(email);
    return n ? `<span class="next" role="button" title="出場予定・結果を見る">次戦 ${mdOf(n.date)} ${esc(dispName(n.race))} ›</span>` : '';
  }
  function resultText(e) {
    if (e.st === '完走') return `${timeOf(e)}　完走`;
    if (e.st === 'DNF') return `DNF　${e.dk}km地点`;
    if (e.st === 'DNS') return 'DNS';
    return e.date < todayStr() ? '結果待ち' : e.date === todayStr() ? '今日' : '出場予定';
  }
  // ---- 「こんな機能が欲しい」要望（2026-10-20）。一覧は全員が見られる・書いた人の名前は出さない（運営だけ分かる）----
  const IDEA = { list: null, screens: [], statuses: [], filter: 'open', form: false, draft: { screen: '', text: '', photo: null }, thumbs: {} };
  const IDEA_CLS = { '受付': 'new', '検討中': 'think', '作っています': 'doing', 'できました': 'done', '今回は見送り': 'skip' };
  async function openIdeas() {
    const el = openSheet('💡 こんな機能が欲しい', '<div class="mz-loading" style="padding:16px">読み込んでいます…</div>', (el) => bindIdeas(el));
    if (IDEA.list) drawIdeas(el); // 先に読んでおいた一覧をすぐ出し、最新は裏で
    await loadIdeas(el);
  }
  async function loadIdeas(el) {
    let d; try { d = await api('ideaList'); } catch (e) { return; }
    if (!d.ok) return;
    const same = IDEA.list && JSON.stringify(IDEA.list) === JSON.stringify(d.list);
    IDEA.list = d.list; IDEA.screens = d.screens; IDEA.statuses = d.statuses;
    if (!el) return; // 先読み
    if (!same || !$('.mz-idea, #id-open', el)) { const busy = el.contains(document.activeElement) && /TEXTAREA|INPUT|SELECT/.test(document.activeElement.tagName); if (!busy) drawIdeas(el); }
    // スクショの小さい写真
    const need = d.list.filter(x => x.photo && !IDEA.thumbs[x.id]).map(x => x.id);
    for (let i = 0; i < need.length; i += 20) {
      try { const t = await api('photoThumbs', { kind: 'idea', ids: need.slice(i, i + 20) }); if (t.ok) Object.assign(IDEA.thumbs, t.thumbs); } catch (e) { /* なくても使える */ }
    }
    if (need.length) drawIdeas(el);
  }
  function drawIdeas(el) {
    const L = IDEA.list || [], f = IDEA.filter;
    const shown = L.filter(x => f === 'all' || (f === 'open' ? ['受付', '検討中', '作っています'].includes(x.status) : x.status === f))
      .sort((a, b) => b.votes - a.votes || b.at.localeCompare(a.at));
    const D = IDEA.draft;
    const form = IDEA.form ? `<div class="mz-ideaform">
        <label class="mz-field"><span>どの画面のこと？</span><select id="id-screen"><option value="">選んでください</option>${IDEA.screens.map(x => `<option${D.screen === x ? ' selected' : ''}>${esc(x)}</option>`).join('')}</select></label>
        <label class="mz-field"><span>どんな機能が欲しい？困っていること<em>必須</em></span><textarea id="id-text" maxlength="1000" rows="4" placeholder="例：練習記録に、走ったコースの写真を何枚か付けたい">${esc(D.text)}</textarea></label>
        <div class="mz-field"><span>スクショ（任意・1枚）</span>${D.photo ? `<img src="${D.photo.thumb}" alt="" class="mz-phprev">` : ''}
          <div class="acts" style="justify-content:flex-start"><label class="mz-btn ghost sm" style="cursor:pointer">${D.photo ? '替える' : '画像を選ぶ'}<input type="file" accept="image/*" id="id-photo" hidden></label>${D.photo ? '<button type="button" class="mz-btn ghost sm" id="id-phdel">外す</button>' : ''}</div></div>
        <p class="hint">書いた人の名前は、ほかのメンバーには出ません（運営だけが分かります）。</p>
        <div id="id-err"></div>
        <div class="acts"><button type="button" class="mz-btn ghost sm" id="id-cancel">やめる</button><button type="button" class="mz-btn" id="id-send">送る</button></div></div>`
      : '<button type="button" class="mz-add" id="id-open">＋ 要望を書く</button>';
    const tabs = [['open', '受付中'], ['できました', 'できました'], ['今回は見送り', '見送り'], ['all', 'すべて']];
    const item = x => `<div class="mz-idea" data-iid="${esc(x.id)}">
        <div class="top"><span class="st ${IDEA_CLS[x.status] || ''}">${esc(x.status)}</span><span class="sc">${esc(x.screen)}</span><span class="dt">${esc(mdOf(x.at.slice(0, 10)))}</span>${x.mine ? '<span class="mine">自分の要望</span>' : ''}${S.me.admin && x.who ? `<span class="who">${esc(x.who)}</span>` : ''}</div>
        <div class="tx">${esc(x.text)}</div>
        ${x.photo ? `<button type="button" class="mz-photo" data-iph="${esc(x.id)}">${IDEA.thumbs[x.id] ? `<img src="${IDEA.thumbs[x.id]}" alt="">` : '<span class="ph-wait">スクショ</span>'}</button>` : ''}
        ${x.reply ? `<div class="reply"><b>運営より</b>${esc(x.reply)}</div>` : ''}
        <div class="acts" style="justify-content:flex-start"><button type="button" class="mz-vote${x.voted ? ' on' : ''}" data-ivote${x.mine ? ' disabled title="自分の要望には押せません"' : ''}>👍 わたしも欲しい${x.votes ? ` <b>${x.votes}</b>` : ''}</button>
          ${x.mine || S.me.admin ? '<button type="button" class="mz-linkbtn" data-idel>消す</button>' : ''}</div>
        ${S.me.admin ? `<div class="mz-ideaadm"><select data-ist>${IDEA.statuses.map(s => `<option${s === x.status ? ' selected' : ''}>${esc(s)}</option>`).join('')}</select><input data-irep maxlength="300" value="${esc(x.reply)}" placeholder="運営のひとこと（全員に見えます）"><button type="button" class="mz-btn sm" data-isave>保存</button></div>` : ''}
      </div>`;
    $('.in', el).innerHTML = `<p class="hint">名鑑・練習記録に「こんな機能が欲しい」「ここが使いにくい」を送ってください。同じことを思ったら👍を押すだけでOKです。👍が多いものから考えます。</p>
      ${form}
      <div class="mz-ideatabs">${tabs.map(([k, l]) => `<button type="button" data-itab="${esc(k)}" aria-pressed="${f === k}">${l}</button>`).join('')}</div>
      ${shown.map(item).join('') || '<p class="hint">まだありません。最初のひとつをどうぞ</p>'}`;
  }
  function bindIdeas(el) {
    el.addEventListener('click', async ev => {
      const t = ev.target;
      if (t.closest('#id-open')) { IDEA.form = true; drawIdeas(el); $('#id-text', el).focus(); return; }
      if (t.closest('#id-cancel')) { IDEA.form = false; drawIdeas(el); return; }
      if (t.closest('#id-phdel')) { IDEA.draft.photo = null; drawIdeas(el); return; }
      if (t.closest('[data-itab]')) { IDEA.filter = t.closest('[data-itab]').dataset.itab; drawIdeas(el); return; }
      const card = t.closest('[data-iid]'), id = card && card.dataset.iid;
      if (t.closest('[data-iph]')) { const s2 = openSheet('スクショ', '<div class="mz-loading" style="padding:16px">読み込んでいます…</div>'); s2.classList.add('mz-photobox'); api('photoFull', { kind: 'idea', id }).then(d => { $('.in', s2).innerHTML = d.ok ? `<img src="${d.src}" alt="" class="mz-photofull">` : '<p class="hint">読み込めませんでした</p>'; }); return; }
      if (t.closest('#id-send')) {
        const D = IDEA.draft; D.text = $('#id-text', el).value.trim(); D.screen = $('#id-screen', el).value;
        if (!D.text) { $('#id-err', el).innerHTML = '<div class="mz-errors" role="alert">どんな機能が欲しいか書いてください</div>'; return; }
        const b = t.closest('#id-send'); b.disabled = true; b.textContent = '送っています…';
        try {
          const d = await api('ideaSave', { screen: D.screen || 'その他', text: D.text });
          if (!d.ok) throw new Error(d.reason);
          if (D.photo) { const p = await api('photoUpload', { kind: 'idea', id: d.id, full: D.photo.full, thumb: D.photo.thumb }).catch(() => ({ ok: false })); if (p.ok) IDEA.thumbs[d.id] = D.photo.thumb; }
          IDEA.draft = { screen: '', text: '', photo: null }; IDEA.form = false; IDEA.filter = 'open';
          toast('送りました。ありがとうございます'); await loadIdeas(el);
        } catch (x) { b.disabled = false; b.textContent = '送る'; $('#id-err', el).innerHTML = `<div class="mz-errors" role="alert">送れませんでした（${esc(x.message)}）</div>`; }
        return;
      }
      if (t.closest('[data-ivote]')) {
        const b = t.closest('[data-ivote]'); if (b.disabled) return; b.disabled = true;
        try { const d = await api('reactClap', { kind: 'idea', id }); if (d.ok) { const x = IDEA.list.find(y => y.id === id); x.votes = d.react.claps; x.voted = d.react.clapped; drawIdeas(el); } } catch (e) { b.disabled = false; }
        return;
      }
      if (t.closest('[data-idel]')) {
        if (!confirm('この要望を消しますか？')) return;
        const d = await api('ideaDelete', { id }); if (d.ok) { IDEA.list = d.list; drawIdeas(el); toast('消しました'); }
        return;
      }
      if (t.closest('[data-isave]')) {
        const d = await api('ideaStatus', { id, status: $('[data-ist]', card).value, reply: $('[data-irep]', card).value });
        if (d.ok) { IDEA.list = d.list; S.ideaCount = d.list.filter(x => x.status === '受付').length; drawIdeas(el); toast('保存しました'); }
      }
    });
    el.addEventListener('input', ev => { if (ev.target.id === 'id-text') IDEA.draft.text = ev.target.value; });
    el.addEventListener('change', async ev => {
      if (ev.target.id === 'id-screen') IDEA.draft.screen = ev.target.value;
      if (ev.target.id === 'id-photo' && ev.target.files[0]) {
        IDEA.draft.text = $('#id-text', el).value;
        try { IDEA.draft.photo = await shrinkPhoto(ev.target.files[0]); } catch (x) { toast('この画像は読み込めませんでした'); }
        drawIdeas(el);
      }
    });
  }

  // ---- レース結果への応援（👏）とコメント（2026-10-19。練習記録と同じ仕組み・見られるのはメンバー全員） ----
  const RX = {}, RX_WAIT = new Set(), RX_OPEN = new Set(), RX_DRAFT = {}, PH = {}, PH_WAIT = new Set();
  const rxTime = at => new Date(at).toLocaleString('ja-JP', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  // compact：「大会予定・結果」の1行に収める（名前・結果と同じ行の右端に👏💬）
  const reactBarHTML = (e, compact) => `<div class="mz-react${compact ? ' compact' : ''}" data-rid="${esc(e.id)}" data-own="${S.me && e.email === S.me.email ? 1 : ''}"${compact ? ' data-compact="1"' : ''}>${reactInner(e.id, S.me && e.email === S.me.email, compact)}</div>`;
  // 本名さん（呼び名）。誰か分かるように（2026-10-19）
  const personText = email => { const f = fullNameOf(email), n = nameOf(email); return `${f || n}さん${n && f && normR(n) !== normR(f) ? `（${n}）` : ''}`; }; // SNS用の文章も本名さん（呼び名）
  const personLabel = email => { const f = fullNameOf(email), n = nameOf(email); return `${esc(f || n)}さん${n && f && normR(n) !== normR(f) ? `<small>（${esc(n)}）</small>` : ''}`; };
  // その場で開くコメント欄（別の画面にしない 2026-10-19）。閉じているときは最新2件だけ見せる
  function reactInner(id, own, compact) {
    const r = RX[id] || { claps: 0, clapped: false, clappers: [], comments: [] }, open = RX_OPEN.has(id);
    // 写真：ふつうは横長で大きく、1行の欄（compact）では小さな四角
    const ph = r.photo ? `<button type="button" class="mz-photo${compact ? ' sq' : ''}" data-photo aria-label="写真を大きく見る">${PH[id] ? `<img src="${PH[id]}" alt="">` : '<span class="ph-wait">写真</span>'}</button>` : '';
    const msg = c => `<div class="mz-rxmsg${c.email === S.me.email ? ' me' : ''}"><div class="who">${esc(c.email === S.me.email ? '自分' : c.name)}　${esc(rxTime(c.at))}${c.canDel ? ` <button type="button" class="mz-linkbtn" data-rxdel="${esc(c.id)}">消す</button>` : ''}</div>${esc(c.text)}</div>`;
    const more = open ? '' : r.comments.length > 2 ? `<button type="button" class="mz-linkbtn" data-cmt>コメントをすべて見る（${r.comments.length}件）</button>` : '';
    const thread = (open ? r.comments : r.comments.slice(-2)).map(msg).join('');
    return `${compact ? '' : ph}<div class="row">${compact ? ph : ''}${reactRowHTML(r, own, open)}</div>${more}${thread ? `<div class="mz-rxthread">${thread}</div>` : ''}`
      + (open ? `<div class="mz-rxform"><textarea data-rxta maxlength="500" rows="2" placeholder="コメントを書く">${esc(RX_DRAFT[id] || '')}</textarea><button type="button" class="mz-btn" data-rxsend>送る</button></div><div class="mz-rxerr"></div>` : '');
  }
  function reactRowHTML(r, own, open) {
    return `<button type="button" class="clap${r.clapped ? ' on' : ''}" data-clap${own ? ' disabled title="自分の記録には押せません"' : ''} aria-label="応援する">👏${r.claps ? `<b>${r.claps}</b>` : ''}</button>`
      + `<button type="button" class="cmt${open ? ' on' : ''}" data-cmt aria-label="コメント">💬${r.comments.length ? `<b>${r.comments.length}</b>` : ' コメント'}</button>`
      + (r.clappers.length ? `<span class="who">${esc(r.clappers.slice(0, 3).join('・'))}${r.clappers.length > 3 ? ` ほか${r.clappers.length - 3}人` : ''}</span>` : '');
  }
  const repaintReact = id => $$(`.mz-react[data-rid="${CSS.escape(id)}"]`).forEach(b => { b.innerHTML = reactInner(id, b.dataset.own === '1', b.dataset.compact === '1'); });
  async function hydrateReacts() {
    const ids = [];
    $$('.mz-react').forEach(b => { const id = b.dataset.rid; if (!RX[id] && !RX_WAIT.has(id)) { RX_WAIT.add(id); ids.push(id); } });
    if (!ids.length) return;
    try { const d = await api('reactGet', { kind: 'result', ids }); if (d.ok) Object.entries(d.reacts).forEach(([id, r]) => { RX[id] = r; repaintReact(id); }); } catch (e) { /* 読めなくても画面は使える */ }
    ids.forEach(id => RX_WAIT.delete(id));
    loadThumbs();
  }
  async function loadThumbs() {
    const need = [];
    $$('.mz-react').forEach(b => { const id = b.dataset.rid; if (RX[id] && RX[id].photo && !PH[id] && !PH_WAIT.has(id)) { PH_WAIT.add(id); need.push(id); } });
    for (let i = 0; i < need.length; i += 20) {
      const ids = need.slice(i, i + 20);
      try { const d = await api('photoThumbs', { kind: 'result', ids }); if (d.ok) Object.entries(d.thumbs).forEach(([id, src]) => { PH[id] = src; repaintReact(id); }); } catch (e) { /* 読めなくても画面は使える */ }
      ids.forEach(id => PH_WAIT.delete(id));
    }
  }
  // 写真を縮める（長い辺1200px／一覧用720px）。作り直すので位置情報などは消える。iPhoneの写真もここでJPEGになる
  async function shrinkPhoto(file) {
    let img;
    try { img = await createImageBitmap(file, { imageOrientation: 'from-image' }); }
    catch (e) { img = await new Promise((ok, ng) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ng; i.src = URL.createObjectURL(file); }); }
    const make = (max, q) => { const w = img.width, h = img.height, s = Math.min(1, max / Math.max(w, h)); const c = document.createElement('canvas'); c.width = Math.round(w * s); c.height = Math.round(h * s); c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); return c.toDataURL('image/jpeg', q); };
    return { full: make(1200, 0.8), thumb: make(720, 0.7) };
  }
  function openPhoto(id) {
    const el = openSheet('写真', '<div class="mz-loading" style="padding:16px">読み込んでいます…</div>');
    el.classList.add('mz-photobox');
    api('photoFull', { kind: 'result', id }).then(d => { $('.in', el).innerHTML = d.ok ? `<img src="${d.src}" alt="" class="mz-photofull">` : '<p class="hint">写真を読み込めませんでした</p>'; }).catch(() => {});
  }
  // 結果の入力欄の写真（草稿 EC.res[id] に photo／photoRemove を持つ）
  document.addEventListener('change', async ev => {
    const inp = ev.target.closest('[data-rphoto]'); if (!inp || !inp.files[0]) return;
    const id = inp.dataset.rphoto, R = EC.res[id]; if (!R) return;
    try { R.photo = await shrinkPhoto(inp.files[0]); R.photoRemove = false; } catch (x) { toast('この写真は読み込めませんでした'); }
    renderEntryTab();
  });
  function resultPhotoHTML(e, R) {
    const has = !!(RX[e.id] && RX[e.id].photo) && !R.photoRemove, src = R.photo ? R.photo.thumb : has ? PH[e.id] : '';
    return `<div class="mz-field"><span>写真（1枚・任意）<em style="font-weight:400">メンバーだけが見られます</em></span>
      ${src ? `<img src="${src}" alt="" class="mz-phprev">` : has ? '<p class="hint">写真あり</p>' : ''}
      <div class="acts" style="justify-content:flex-start"><label class="mz-btn ghost sm" style="cursor:pointer">${src || has ? '写真を替える' : '写真を選ぶ'}<input type="file" accept="image/*" data-rphoto="${esc(e.id)}" hidden></label>${src || has ? `<button type="button" class="mz-btn ghost sm" data-rphdel="${esc(e.id)}">写真を外す</button>` : ''}</div></div>`;
  }
  let rxTimer = null;
  new MutationObserver(() => { clearTimeout(rxTimer); rxTimer = setTimeout(hydrateReacts, 200); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', async ev => {
    if (ev.target.closest('[data-rxin]')) { ev.stopPropagation(); openReactInbox(); return; }
    const phd = ev.target.closest('[data-rphdel]');
    if (phd) { ev.stopPropagation(); const R = EC.res[phd.dataset.rphdel]; if (R) { R.photo = null; R.photoRemove = true; renderEntryTab(); } return; }
    const bar = ev.target.closest('.mz-react'); if (!bar) return;
    ev.stopPropagation();
    const id = bar.dataset.rid;
    if (ev.target.closest('[data-photo]')) { openPhoto(id); return; }
    if (ev.target.closest('[data-clap]')) {
      const b = ev.target.closest('[data-clap]'); if (b.disabled) return; b.disabled = true;
      try { const d = await api('reactClap', { kind: 'result', id }); if (d.ok) { RX[id] = d.react; repaintReact(id); } } catch (x) { /* もう一度押せる */ }
      b.disabled = false;
    } else if (ev.target.closest('[data-cmt]')) {
      if (RX_OPEN.has(id)) RX_OPEN.delete(id); else RX_OPEN.add(id);
      repaintReact(id);
      const ta = $('[data-rxta]', bar); if (ta) ta.focus();
      if (RX_OPEN.has(id)) api('reactGet', { kind: 'result', ids: [id] }).then(d => { if (d.ok) { RX[id] = d.reacts[id]; if (!(document.activeElement && document.activeElement.closest('.mz-react') === bar)) repaintReact(id); } }).catch(() => {});
    } else if (ev.target.closest('[data-rxsend]')) {
      const ta = $('[data-rxta]', bar), t = ta.value.trim(), b = ev.target.closest('[data-rxsend]');
      if (!t) { $('.mz-rxerr', bar).textContent = '書いてから送ってください'; return; }
      b.disabled = true; b.textContent = '送っています…';
      try { const d = await api('reactComment', { kind: 'result', id, text: t }); if (!d.ok) throw new Error(d.reason); RX[id] = d.react; RX_DRAFT[id] = ''; repaintReact(id); }
      catch (x) { b.disabled = false; b.textContent = '送る'; $('.mz-rxerr', bar).textContent = `送れませんでした（${x.message}）`; }
    } else if (ev.target.closest('[data-rxdel]')) {
      if (!confirm('このコメントを消しますか？')) return;
      const d = await api('reactDelete', { cid: ev.target.closest('[data-rxdel]').dataset.rxdel });
      if (d.ok) { RX[id] = d.react; repaintReact(id); }
    }
  }, true);
  document.addEventListener('input', ev => { const ta = ev.target.closest('[data-rxta]'); if (!ta) return; RX_DRAFT[ta.closest('.mz-react').dataset.rid] = ta.value; });
  function openReact(id) {
    const e = (S.entries || []).find(x => x.id === id);
    const title = e ? `${honor(nameOf(e.email))}・${dispName(e.race)}` : 'コメント';
    const draw = el => {
      const r = RX[id] || { claps: 0, clappers: [], comments: [] };
      $('.in', el).innerHTML = `${e ? `<p class="hint">${esc(mdw(e.date))} ${esc(dispName(e.race))} ${esc(catOf(e))}　${esc(resultText(e))}${e.note ? `<br>${esc(e.note)}` : ''}</p>` : ''}
        ${r.clappers.length ? `<p class="hint">👏 ${esc(r.clappers.join('・'))}</p>` : ''}
        <div class="mz-rxthread">${r.comments.map(c => `<div class="mz-rxmsg${c.email === S.me.email ? ' me' : ''}"><div class="who">${esc(c.email === S.me.email ? '自分' : c.name)}　${esc(new Date(c.at).toLocaleString('ja-JP', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }))}${c.canDel ? ` <button type="button" class="mz-linkbtn" data-rxdel="${esc(c.id)}">消す</button>` : ''}</div>${esc(c.text)}</div>`).join('') || '<p class="hint">まだコメントはありません。最初のひとことをどうぞ</p>'}</div>
        <label class="mz-field"><span>コメントを書く</span><textarea id="rx-cm" maxlength="500" rows="3"></textarea></label>
        <div id="rx-err"></div>
        <button type="button" class="mz-btn" id="rx-send">送る</button>`;
      $('#rx-send', el).onclick = async () => {
        const t = $('#rx-cm', el).value.trim();
        if (!t) { $('#rx-err', el).innerHTML = '<div class="mz-errors" role="alert">書いてから送ってください</div>'; return; }
        const b = $('#rx-send', el); b.disabled = true; b.textContent = '送っています…';
        try { const d = await api('reactComment', { kind: 'result', id, text: t }); if (!d.ok) throw new Error(d.reason); RX[id] = d.react; repaintReact(id); draw(el); toast('送りました'); }
        catch (x) { b.disabled = false; b.textContent = '送る'; $('#rx-err', el).innerHTML = `<div class="mz-errors" role="alert">送れませんでした（${esc(x.message)}）</div>`; }
      };
      $$('[data-rxdel]', el).forEach(b => b.onclick = async () => {
        if (!confirm('このコメントを消しますか？')) return;
        const d = await api('reactDelete', { cid: b.dataset.rxdel });
        if (d.ok) { RX[id] = d.react; repaintReact(id); draw(el); }
      });
    };
    openSheet(title, '<div class="mz-loading" style="padding:16px">読み込んでいます…</div>', el => {
      api('reactGet', { kind: 'result', ids: [id] }).then(d => { if (d.ok) RX[id] = d.reacts[id]; repaintReact(id); draw(el); }).catch(() => draw(el));
    });
  }
  async function openReactInbox() {
    let d; try { d = await api('reactInbox'); } catch (e) { return; }
    S.reactNotice = { claps: 0, comments: 0 }; $$('[data-rxin]').forEach(b => b.remove());
    const TR = 'https://go-trail.net/pages/milers-training';
    openSheet('届いた応援・コメント', d.list.length ? d.list.map(x => `<button type="button" class="mz-rxrow" data-rxgo="${esc(x.kind)}" data-rxid="${esc(x.target)}"><span>${x.isNew ? '<b class="mz-new">新着</b> ' : ''}${esc(x.name)}　${x.type === '応援' ? '👏' : '💬 ' + esc(x.text.slice(0, 40))}<br><small>${esc(x.label)}</small></span><span>›</span></button>`).join('') : '<p class="hint">まだ届いていません</p>', (el, close) => {
      $$('[data-rxgo]', el).forEach(b => b.onclick = () => {
        if (b.dataset.rxgo === 'log') { location.href = `${TR}?react=${encodeURIComponent('log:' + b.dataset.rxid)}`; return; }
        close(); openReact(b.dataset.rxid);
      });
    });
  }

  function resultHTML(e) {
    const cls = e.st === '完走' ? 'ok' : e.st ? 'ng' : 'wait';
    return `<span class="res ${cls}">${esc(resultText(e))}</span>`;
  }

  // 下に出る小窓（拡大表示の上にも重ねられる）
  function openSheet(title, html, bind) {
    $$('.mz-sheet').forEach(x => x.remove());
    const el = document.createElement('div');
    el.className = 'mz-sheet'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', title);
    el.innerHTML = `<div class="panel"><div class="bar"><b>${esc(title)}</b><button type="button" class="mz-btn ghost" data-close>閉じる</button></div><div class="in">${html}</div></div>`;
    root.appendChild(el);
    document.body.style.overflow = 'hidden';
    const close = () => { el.remove(); if (!V && !E) document.body.style.overflow = ''; };
    el.addEventListener('click', e => { if (e.target === el || e.target.closest('[data-close]')) close(); });
    if (bind) bind(el, close);
    return el;
  }

  // ある人の出場予定・結果
  function personEntriesHTML(list) {
    const t = todayStr();
    const up = list.filter(e => !e.st && e.date >= t).sort((a, b) => a.date.localeCompare(b.date));
    const past = list.filter(e => !(!e.st && e.date >= t)).sort((a, b) => b.date.localeCompare(a.date));
    const row = e => `<div class="mz-erow"><div><div class="nm">${esc(dispName(e.race))} <small>${esc(catOf(e))}</small></div><div class="dt">${mdw(e.date)}${e.date.slice(0, 4) !== t.slice(0, 4) ? ' ' + e.date.slice(0, 4) : ''}</div>${e.note ? `<div class="note">${esc(e.note)}</div>` : ''}</div>${resultHTML(e)}</div>${e.st ? reactBarHTML(e) : ''}`;
    return (up.length ? `<h4>出場予定</h4>${up.map(row).join('')}` : '')
      + (past.length ? `<h4>結果</h4>${past.map(row).join('')}` : '')
      || '<p class="hint">まだ登録がありません。</p>';
  }
  function openPersonEntries(c) {
    openSheet(`${honor(c.nick || c.name)}の出場予定・結果`, personEntriesHTML(entriesOf(c.email)));
  }

  // ---- 一覧にない大会の追加依頼（2026-10-16：レースは選ぶだけにした） ----
  function openRaceRequest(name, onExists) {
    openSheet('大会の追加を頼む', `<p class="hint">運営が確かめて一覧に足します（数日かかることがあります）。足されたら、候補から選べるようになります。</p>
      <label class="mz-field"><span>大会名（公式の名前）<em>必須</em></span><input id="rr-name" maxlength="60" value="${esc(name || '')}"></label>
      <label class="mz-field"><span>国内／海外<em>必須</em></span><select id="rr-ov"><option value="">選んでください</option><option value="0">国内</option><option value="1">海外</option></select></label>
      <label class="mz-field"><span>公式サイトのURL（わかれば）</span><input id="rr-url" type="url" inputmode="url" maxlength="300" placeholder="https://"></label>
      <label class="mz-field"><span>運営へのひとこと（任意）</span><input id="rr-note" maxlength="100" placeholder="例：2019年の第1回に出ました"></label>
      <div id="rr-err"></div>
      <button type="button" class="mz-btn" id="rr-send">運営に頼む</button>`, (el, close) => {
      $('#rr-send', el).onclick = async () => {
        const nm = $('#rr-name', el).value.trim(), ov = $('#rr-ov', el).value;
        const err = !nm ? '大会名を入れてください' : !ov ? '国内か海外かを選んでください' : '';
        if (err) { $('#rr-err', el).innerHTML = `<div class="mz-errors" role="alert">${esc(err)}</div>`; return; }
        const b = $('#rr-send', el); b.disabled = true; b.textContent = '送っています…';
        try {
          const d = await api('raceRequest', { name: nm, ov: ov === '1', url: $('#rr-url', el).value.trim(), note: $('#rr-note', el).value.trim() });
          if (!d.ok) throw new Error(d.reason);
          close();
          if (d.exists) { toast(`「${d.exists}」は一覧にありました。そのまま選びました`); if (onExists) onExists(d.exists); }
          else toast('運営に頼みました。一覧に足されたら選べるようになります');
        } catch (e) { if (e.message !== 'auth') { b.disabled = false; b.textContent = '運営に頼む'; $('#rr-err', el).innerHTML = `<div class="mz-errors" role="alert">送れませんでした（${esc(e.message)}）</div>`; } }
      };
    });
  }

  // ---- チームの大会ページ ----
  function weekRanges(base) {
    const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    d.setDate(d.getDate() - ((d.getDay() - 3 + 7) % 7)); // いちばん近い（過ぎた）水曜
    const mon = new Date(d); mon.setDate(d.getDate() - 2);
    const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
    const pmon = new Date(mon); pmon.setDate(mon.getDate() - 7);
    const psun = new Date(mon); psun.setDate(mon.getDate() - 1);
    return { wed: ymd(d), cur: [ymd(mon), ymd(sun)], prev: [ymd(pmon), ymd(psun)] };
  }
  const inRange = (e, [a, b]) => e.date >= a && e.date <= b;
  // 同じ大会・種目・日付ごとにまとめる
  function groupRaces(list) {
    const g = {};
    // 同じ日・同じ大会（「(TPGT)」のような括弧書きだけ違う名前も同じ）・同じ距離を1つに。種目の書き方違い（160K／160km）もまとめる
    const base = n => { const c = canonName(n), d = dbIdx()[normR(c)]; return normR((d ? d.name : c).replace(/\s*[（(][^）)]*[）)]\s*$/, '')); };
    list.forEach(e => {
      const k = e.date + '|' + base(e.race) + '|' + (e.km ? Math.round(e.km) : catOf(e));
      const x = g[k] = g[k] || { date: e.date, race: canonName(e.race), cat: catOf(e), km: e.km, names: [], list: [] };
      if (!x.names.includes(e.race)) x.names.push(e.race);
      if (dispName(e.race).length < dispName(x.race).length) x.race = canonName(e.race); // 表示は短い名前（TPGT など）
      const dup = x.list.findIndex(y => y.email === e.email); // 同じ人の二重登録は1回だけ（結果が入っている方を残す）
      if (dup < 0) x.list.push(e); else if (!x.list[dup].st && e.st) x.list[dup] = e;
    });
    return Object.values(g).sort((a, b) => a.date.localeCompare(b.date) || a.race.localeCompare(b.race, 'ja'));
  }
  // まとめた大会の公式サイト。名前が複数あるときは、その距離の種目を持つ大会のページを選ぶ
  function groupInfo(g) {
    const infos = (g.names || [g.race]).map(dbInfo).filter(i => i && i.url);
    for (const i of infos) { const c = g.km && (i.cats || []).find(c => Math.abs(c.km - g.km) <= 2); if (c) return c.url ? Object.assign({}, i, { url: c.url }) : i; } // 種目ごとのページがあればそちら
    return infos[0] || dbInfo(g.race);
  }
  function boardData() {
    const w = weekRanges(jstToday());
    const cur = (S.entries || []).filter(e => inRange(e, w.cur) && e.st !== 'DNS');
    const prev = (S.entries || []).filter(e => inRange(e, w.prev) && e.st !== 'DNS');
    const later = (S.entries || []).filter(e => e.date > w.cur[1] && !e.st);
    return { w, cur: groupRaces(cur), prev: groupRaces(prev), later: groupRaces(later) };
  }
  const rangeLabel = ([a, b]) => `${mdOf(a)}〜${mdOf(b)}`;
  function boardHTML(b) {
    const raceName = g => { const i = groupInfo(g); return i && i.url ? `<a href="${esc(i.url)}" target="_blank" rel="noopener">${esc(dispName(g.race))}</a>` : esc(dispName(g.race)); };
    const raceBlock = (g, withResult, wx) => `<div class="mz-bgroup"><div class="hd"><span class="dt">${mdw(g.date)}</span><b>${raceName(g)}</b><small>${esc(g.cat)}</small><span class="n">${g.list.length}人</span>${wx ? `<span class="wx" data-wx="${esc(g.race + '|' + g.date)}"></span>` : ''}</div>
      ${g.list.slice().sort((x, y) => (x.st === '完走' ? 0 : 1) - (y.st === '完走' ? 0 : 1) || ((x.h * 60 + x.m) || 0) - ((y.h * 60 + y.m) || 0)).map(e => `<div class="mz-erow small${withResult && e.st ? ' rx' : ''}"><button type="button" class="who" data-who="${esc(e.email)}">${personLabel(e.email)}</button>${withResult ? resultHTML(e) : ''}${withResult && e.st ? reactBarHTML(e, true) : ''}</div>`).join('')}</div>`;
    return `<p class="hint">毎週水曜に切り替わります（いまは ${mdOf(b.w.wed)}（水）の週）。メンバーが入れた予定・結果から自動で作っています。</p>
      ${isStaff() ? `<div class="mz-sns"><button type="button" class="mz-btn" id="b-copy">SNS用の文章をコピー</button><span class="hint">投稿の前に、名前と結果を確かめてください</span></div>` : ''}
      <h4>今週のレース予定 <small>${rangeLabel(b.w.cur)}</small></h4>
      ${b.cur.length ? b.cur.map(g => raceBlock(g, false, true)).join('') : '<p class="hint">今週の登録はまだありません。</p>'}
      <h4>先週のレース結果 <small>${rangeLabel(b.w.prev)}</small></h4>
      ${b.prev.length ? b.prev.map(g => raceBlock(g, true)).join('') : '<p class="hint">先週の登録はありません。</p>'}
      <h4>これから先の大会 <small>来週以降・メンバーが登録した予定</small></h4>
      ${b.later.length ? b.later.map(g => raceBlock(g, false, true)).join('') : '<p class="hint">来週以降の登録はまだありません。</p>'}
`;
  }
  // ---- 大会の日の天気予報（Open-Meteo・無料・鍵なし。予報が出るのは今日から15日先まで） ----
  const WX = {};
  // WMOの天気コード → 日本語と、SNSに添えるひとこと
  function wxKind(code, pop) {
    if (code >= 95) return { label: '雷雨', kind: 'storm' };
    if ((code >= 61 && code <= 67) || (code >= 80 && code <= 82)) return { label: pop >= 70 || code === 65 || code === 82 ? '雨' : 'ところにより雨', kind: pop >= 70 ? 'rain' : 'shower' };
    if (code >= 51 && code <= 57) return { label: '霧雨', kind: 'shower' };
    if (code >= 71 && code <= 77 || code === 85 || code === 86) return { label: '雪', kind: 'snow' };
    if (code === 45 || code === 48) return { label: '霧', kind: 'cloud' };
    if (code === 3) return { label: 'くもり', kind: 'cloud' };
    if (code === 2) return { label: '晴れ時々くもり', kind: 'sun' };
    return { label: '晴れ', kind: 'sun' };
  }
  const WX_WORD = { sun: 'いい天気になりそう！', cloud: '晴れてくれ！', shower: '雨がぱらつくかも。晴れてくれ！', rain: '雨の予報です。晴れてくれ！', snow: '雪の予報。暖かくして！', storm: '荒れ模様！どうか無事に' };
  async function weatherFor(name, date) {
    const key = name + '|' + date;
    if (key in WX) return WX[key];
    WX[key] = null;
    const days = (new Date(date + 'T00:00:00+09:00') - new Date(todayStr() + 'T00:00:00+09:00')) / 86400000;
    if (days < 0 || days > 15) return null;
    await loadDbRaces();
    const info = dbInfo(name);
    if (!info || !info.pos) return null;
    try {
      const u = `https://api.open-meteo.com/v1/forecast?latitude=${info.pos[0]}&longitude=${info.pos[1]}&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max&timezone=auto&start_date=${date}&end_date=${date}`;
      const d = await (await fetch(u)).json();
      const dl = d.daily || {};
      if (!dl.time || !dl.time.length) return null;
      const pop = dl.precipitation_probability_max[0];
      const k = wxKind(dl.weather_code[0], pop == null ? 0 : pop);
      WX[key] = Object.assign(k, { tmax: Math.round(dl.temperature_2m_max[0]), tmin: Math.round(dl.temperature_2m_min[0]), pop });
    } catch (e) { WX[key] = null; }
    return WX[key];
  }
  const wxText = w => w ? `${w.label}（最高${w.tmax}℃・最低${w.tmin}℃${w.pop != null ? `・降水確率${w.pop}%` : ''}）` : '';

  // SNS（メンバー限定の非公開ページ）に貼る文章。毎週水曜に、今週の出走と先週の結果を紹介する
  // 結果には本人が書いた「ひとこと」を添える（作った言葉ではなく本人の言葉で温度を出す）
  async function snsText(b) {
    const wx = await Promise.all(b.cur.map(g => weatherFor(g.race, g.date)));
    const people = new Set(b.cur.flatMap(g => g.list.map(e => e.email))).size;
    const allWeekend = b.cur.every(g => { const [y, m, d] = g.date.split('-').map(Number); const w = new Date(y, m - 1, d).getDay(); return w === 0 || w === 6; });
    const when = allWeekend ? '今週末' : '今週';
    const lines = ['皆さまこんにちは！', ''];
    if (b.cur.length) {
      lines.push(`${when}のマイラーズの出走は、${people}人です。`);
      // 天気でひとこと（荒れる大会が1つでもあれば荒れ模様、全部晴れならいい天気）
      const ks = wx.filter(Boolean).map(w => w.kind);
      if (ks.some(k => k === 'storm' || k === 'rain')) lines.push(`${when}は荒れ模様！ 晴れてくれ！`);
      else if (ks.length && ks.every(k => k === 'sun')) lines.push(`${when}はいい天気になりそう！`);
      lines.push('');
      b.cur.forEach((g, i) => {
        lines.push(`■ ${mdw(g.date)} ${dispName(g.race)} ${g.cat}`, `　${g.list.map(e => personText(e.email)).join('、')}`);
        if (wx[i]) lines.push(`　天気：${wxText(wx[i])}　${WX_WORD[wx[i].kind]}`);
        const info = groupInfo(g);
        if (info && info.url) lines.push(`　${info.url}`);
      });
      lines.push('', '応援よろしくお願いします！');
    } else lines.push(`${when}のマイラーズの出走はありません。`);
    if (b.prev.length) {
      lines.push('', '———', '', '先週のレースの結果です。', '');
      b.prev.forEach(g => {
        lines.push(`■ ${dispName(g.race)} ${g.cat}`);
        g.list.forEach(e => {
          lines.push(`　${personText(e.email)}　${e.st === '完走' ? timeOf(e) + 'で完走' : e.st === 'DNF' ? e.dk + 'km地点でDNF' : '（結果待ち）'}`);
          if (e.note) lines.push(`　「${e.note}」`);
        });
      });
      lines.push('', 'おつかれさまでした！');
    }
    return lines.join('\n');
  }

  // ---------- カレンダー（2026-11-03） ----------
  // 予定は別のファイル milers-calendar.js（window.MILERS_CALENDAR）に入っている。週1回 予定表を作る.py で作り直して上げ直す
  // 今週（7日間）→ 今月のこのあと → その先は月ごとに閉じた箱（押すと開く）
  const CAL_T = { race: '大会', event: '試走会・整備ほか', vol: 'ボランティア', prac: '練習会', mtg: 'ミーティング' };
  const CAL = { on: new Set(Object.keys(CAL_T)), team: '' };
  function calRowHTML(e) {
    const [, m, d] = e.date.split('-').map(Number);
    let end = '';
    if (e.end) { const [, m2, d2] = e.end.split('-').map(Number); end = '〜' + (m2 !== m ? m2 + '/' : '') + d2; }
    const [y] = e.date.split('-').map(Number);
    const w = WD[new Date(y, m - 1, d).getDay()];
    const member = e.members_only || e.type === 'prac' || e.type === 'mtg';
    const sub = [e.team, e.status, member ? 'メンバーのみ' : ''].filter(Boolean).join('　');
    const go = e.type === 'prac' || e.type === 'mtg' ? (e.fb ? 'Facebook ›' : 'チーム ›') : '開く ›';
    return `<a class="ev" href="${esc(e.fb || e.url)}" target="_blank" rel="noopener"><div class="d">${d}<small>${w}${end}</small></div><span class="tag t-${esc(e.type)}">${esc(CAL_T[e.type] || '')}</span><div class="nm"><b>${esc(e.title)}</b>${sub ? `<span>${esc(sub)}</span>` : ''}</div><span class="go">${go}</span></a>`;
  }
  function calListHTML(events) {
    const now = todayStr();
    const wkD = jstToday(); wkD.setDate(wkD.getDate() + 7); const wk = ymd(wkD);
    const curM = now.slice(0, 7);
    const ev = events.filter(e => CAL.on.has(e.type) && (!CAL.team || e.team === CAL.team || e.team === '全チーム'));
    const empty = t => `<div class="empty">${t}</div>`;
    const week = ev.filter(e => (e.end || e.date) >= now && e.date < wk);
    const month = ev.filter(e => e.date.slice(0, 7) === curM && e.date >= wk);
    const groups = {};
    ev.filter(e => e.date.slice(0, 7) > curM).forEach(e => { const k = e.date.slice(0, 7); (groups[k] = groups[k] || []).push(e); });
    return `<div class="mo">今週（7日間）</div>${week.length ? week.map(calRowHTML).join('') : empty('この1週間の予定はありません')}`
      + `<div class="mo">${Number(curM.slice(5))}月のこのあと</div>${month.length ? month.map(calRowHTML).join('') : empty('今月のこのあとの予定はありません')}`
      + `<div class="mo later">その先の予定</div>`
      + (Object.keys(groups).length ? Object.keys(groups).sort().map(k => `<details class="mon"><summary><b>${Number(k.slice(0, 4))}年${Number(k.slice(5))}月</b><span>${groups[k].length}件 ›</span></summary>${groups[k].map(calRowHTML).join('')}</details>`).join('') : empty('その先の予定はまだありません'));
  }
  // トップ画面の「今週の予定」（全種類・最大6件）。その先は「カレンダーを開く」で
  function calTopHTML() {
    const D = window.MILERS_CALENDAR;
    if (!D || !Array.isArray(D.events)) return '';
    const now = todayStr();
    const wkD = jstToday(); wkD.setDate(wkD.getDate() + 7); const wk = ymd(wkD);
    const week = D.events.filter(e => (e.end || e.date) >= now && e.date < wk);
    const rest = D.events.filter(e => e.date >= wk).length;
    return `<section class="mz-cal mz-caltop"><div class="hd"><b>今週の予定</b><button type="button" class="mz-btn light" id="mz-cal2">その先の予定を見る（${rest}件） ›</button></div>`
      + (week.length ? week.slice(0, 6).map(calRowHTML).join('') + (week.length > 6 ? `<div class="empty">ほか${week.length - 6}件はカレンダーで</div>` : '') : '<div class="empty">この1週間の予定はありません</div>')
      + '</section>';
  }
  function openCalendar() {
    const D = window.MILERS_CALENDAR;
    if (!D || !Array.isArray(D.events)) { openSheet('マイラーズ カレンダー', '<p class="hint">予定を読み込めませんでした。ページを開き直してください。</p>'); return; }
    const teams = [...new Set(D.events.map(e => e.team).filter(Boolean))];
    if (CAL.team && !teams.includes(CAL.team)) CAL.team = '';
    const html = `<div class="mz-cal">
      <p class="hint">練習会・大会・ボランティア・ミーティングの予定です（${esc(mdOf(D.made || todayStr()))} 時点）。押すと各ページが開きます。</p>
      <div class="chips">${Object.entries(CAL_T).map(([k, v]) => `<button type="button" class="chip ${k}${CAL.on.has(k) ? ' on' : ''}" data-ctype="${k}" aria-pressed="${CAL.on.has(k)}">${v}</button>`).join('')}</div>
      <label class="tm">チーム <select data-cteam><option value="">すべて</option>${teams.map(t => `<option${t === CAL.team ? ' selected' : ''}>${esc(t)}</option>`).join('')}</select></label>
      <div data-clist>${calListHTML(D.events)}</div></div>`;
    openSheet('マイラーズ カレンダー', html, el => {
      const redraw = () => { $('[data-clist]', el).innerHTML = calListHTML(D.events); };
      el.addEventListener('click', e => {
        const b = e.target.closest('[data-ctype]'); if (!b) return;
        const k = b.dataset.ctype;
        if (CAL.on.has(k)) CAL.on.delete(k); else CAL.on.add(k);
        b.classList.toggle('on', CAL.on.has(k)); b.setAttribute('aria-pressed', CAL.on.has(k));
        redraw();
      });
      $('[data-cteam]', el).onchange = e => { CAL.team = e.target.value; redraw(); };
    });
  }

  async function openBoard() {
    await loadDbRaces(); // 公式サイトのリンクを付けるため、大会一覧を読み終えてから開く
    const b = boardData();
    openSheet('マイラーズ 大会予定・結果', boardHTML(b), el => {
      // 天気（予報が出ている15日先まで）を、読めたものから表示する
      loadDbRaces().then(() => {
        $$('[data-wx]', el).forEach(async sp => {
          const [race, date] = sp.dataset.wx.split('|');
          const w = await weatherFor(race, date);
          if (w) { sp.textContent = `${w.label} ${w.tmax}℃${w.pop != null ? ` ☂${w.pop}%` : ''}`; sp.classList.add(w.kind); }
        });
      });
      el.addEventListener('click', e => {
        const w = e.target.closest('[data-who]');
        if (w) { const c = S.cards.find(x => x.email === w.dataset.who); if (c) openViewer(c.email, true); else openSheet(`${honor(nameOf(w.dataset.who))}の出場予定・結果`, personEntriesHTML(entriesOf(w.dataset.who))); }
      });
      const cp = $('#b-copy', el);
      if (cp) cp.onclick = async () => {
        cp.disabled = true; cp.textContent = '天気を調べています…';
        const text = await snsText(b);
        cp.disabled = false; cp.textContent = 'SNS用の文章をコピー';
        try { await navigator.clipboard.writeText(text); toast('コピーしました'); }
        catch (err) { openSheet('SNS用の文章', `<textarea class="mz-copybox" readonly>${esc(text)}</textarea><p class="hint">長押しで全部選んでコピーしてください。</p>`); }
      };
    });
  }

  // ---- 名鑑の一番上「あなたの大会」（2026-10-16 ミノリさん：いちばん使うものを、開いてすぐの所に） ----
  // 写真・名前は年に1回、出る大会と結果は大会のたび。なので予定・結果は別の画面を開かず、ここで入れる
  let N = null; // 新しく登録する大会の入力中の状態
  const EC = { target: '', res: {}, openEntry: null, formOpen: false, showAll: false, box: null };
  // 「あなたの大会」を開いて、指定の大会を見せる（カードの編集の戦績や、?entry= から）
  function goEntry(id) {
    if (E) closeEditor();
    if (id) EC.openEntry = id;
    // 結果待ちがなければ、すぐ登録できるように登録欄を開いておく
    else if (!entriesOf(S.me.email).some(e => !e.st && e.date <= todayStr())) EC.formOpen = true;
    renderMyRaces();
    const el = (id && $(`#mz-my .mz-ecard[data-id="${CSS.escape(id)}"]`)) || $('#mz-my');
    if (el) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function blankEntry() { return { race: '', ov: null, cat: '', km: '', date: '', reqKey: 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8) }; }
  function entryFormHTML() {
    const known = N.race ? findRace(N.race) : null;
    const cats = known && (known.cats || []).length ? `<div class="mz-cats"><span>種目</span>${known.cats.map(c => `<button type="button" class="mz-chip" data-ncat="${esc(c.label)}" data-km="${esc(c.km)}" aria-pressed="${N.cat === c.label}">${esc(c.label)}${c.label.includes(String(c.km)) ? '' : `（${esc(c.km)}km）`}</button>`).join('')}</div>` : '';
    const ov = '';
    return `<div class="mz-field"><label for="nq"><span>大会（打つと候補が出ます）<em>必須</em></span></label>
        <div class="mz-combo"><input id="nq" data-n="raceq" maxlength="60" value="${esc(N.race ? dispName(N.race) : '')}" placeholder="例：TPGT、信越、UTMB" autocomplete="off" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="nsugg">
        <div class="mz-sugg" id="nsugg" role="listbox" hidden></div></div></div>
      ${ov}${cats}
      <div class="mz-2col">
        <label class="mz-field"><span>出場する日<em>必須</em></span><input type="date" data-n="date" value="${esc(N.date)}"></label>
        <label class="mz-field"><span>距離（km）<em>必須</em></span><input type="number" inputmode="decimal" min="1" max="1000" data-n="km" value="${esc(N.km)}"></label>
      </div>
      <div id="n-err"></div>
      <button type="button" class="mz-btn" id="n-save">登録する</button>`;
  }
  function entryCardHTML(e) {
    // 入力中の草稿があるあいだは開いたままにする（別の画面で先に結果が入っても、入力が隠れないように）
    const t = todayStr(), canResult = e.date <= t, open = EC.openEntry === e.id || !!EC.res[e.id];
    const head = `<div class="hd"><div><div class="nm">${esc(dispName(e.race))} <small>${esc(catOf(e))}</small></div><div class="dt">${mdw(e.date)}${e.date.slice(0, 4) !== t.slice(0, 4) ? ' ' + e.date.slice(0, 4) : ''}</div></div>${resultHTML(e)}</div>`;
    if (!canResult) return `<div class="mz-ecard" data-id="${esc(e.id)}">${head}<div class="acts"><button type="button" class="mz-btn ghost sm" data-del="${esc(e.id)}">消す</button></div></div>`;
    if (e.st && !open) return `<div class="mz-ecard" data-id="${esc(e.id)}">${head}${e.note ? `<div class="note">${esc(e.note)}</div>` : ''}${reactBarHTML(e)}<div class="acts"><button type="button" class="mz-btn ghost sm" data-open="${esc(e.id)}">直す</button><button type="button" class="mz-btn ghost sm" data-del="${esc(e.id)}">消す</button></div></div>`;
    // 草稿：編集を始めた時点の中身（base）と更新番号（baseRev）を一組で持つ。保存は必ずこの baseRev で送る。
    // 一覧を読み直して S.entries が新しくなっても、草稿の baseRev は勝手に進めない（古い入力で新しい結果を上書きしないため）
    const fresh = () => ({ baseRev: e.rev, base: Object.assign({}, e), st: e.st, h: e.h, m: e.m, dk: e.dk, note: e.note });
    let R = EC.res[e.id] || (EC.res[e.id] = fresh());
    // 何も変えていない草稿なら、黙って最新に入れ替える（聞くのは、入力した内容があるときだけ）
    const untouched = ['st', 'h', 'm', 'dk', 'note'].every(k => String(R[k] == null ? '' : R[k]) === String(R.base[k] == null ? '' : R.base[k]));
    if (R.baseRev !== e.rev && untouched) R = EC.res[e.id] = fresh();
    const stale = R.baseRev !== e.rev;
    return `<div class="mz-ecard open" data-id="${esc(e.id)}">${head}
      ${stale ? `<div class="mz-errors" role="alert">別の画面（ほかのタブやスマホ）で、この結果が先に直されています（いまの内容：${esc(resultText(e))}${e.note ? '・' + esc(e.note) : ''}）。<br>この画面の入力は残しています。どちらにするか選んでください。
        <div class="acts" style="justify-content:flex-start;margin-top:8px"><button type="button" class="mz-btn ghost sm" data-rlatest="${esc(e.id)}">最新を読み込む（この画面の入力は消えます）</button><button type="button" class="mz-btn ghost sm" data-rover="${esc(e.id)}">この画面の入力で上書きする</button></div></div>` : ''}
      <div class="mz-stbtns" role="group" aria-label="結果">${['完走', 'DNF', 'DNS'].map(s => `<button type="button" class="mz-chip" data-st="${s}" aria-pressed="${R.st === s}">${s === 'DNF' ? 'DNF（完走できず）' : s === 'DNS' ? 'DNS（出走せず）' : '完走'}</button>`).join('')}</div>
      ${R.st === '完走' ? `<div class="mz-time"><span>完走タイム</span><input type="number" inputmode="numeric" min="0" max="500" step="1" data-r="h" value="${esc(R.h)}" aria-label="時間"><span>時間</span><input type="number" inputmode="numeric" min="0" max="59" step="1" data-r="m" value="${esc(R.m)}" aria-label="分"><span>分</span></div>` : ''}
      ${R.st === 'DNF' ? `<div class="mz-time"><span>やめた地点</span><input type="number" inputmode="decimal" min="0" max="${esc(e.km)}" step="0.1" data-r="dk" value="${esc(R.dk)}" aria-label="やめた地点（km）"><span>km（全${esc(e.km)}km）</span></div>` : ''}
      ${R.st ? `<label class="mz-field"><span>ひとこと（任意）</span><input data-r="note" maxlength="200" value="${esc(R.note)}" placeholder="例：後半の登りで粘れました"></label>${resultPhotoHTML(e, R)}` : ''}
      <div class="err"></div>
      <div class="acts"><button type="button" class="mz-btn ghost sm" data-del="${esc(e.id)}">消す</button>${e.st ? `<button type="button" class="mz-btn ghost sm" data-close="${esc(e.id)}">やめる</button>` : ''}${stale ? '' : `<button type="button" class="mz-btn" data-rsave="${esc(e.id)}"${R.st ? '' : ' disabled'}>結果を保存</button>`}</div>
    </div>`;
  }
  // 「あなたの大会」の3段目：今週レースに出るメンバー（大会名は公式サイトへのリンク）
  function teamWeekHTML() {
    // 掲示板（水曜切り替え）と違い、ここはカレンダーどおりの月〜日
    const d = jstToday(), mon = new Date(d.getFullYear(), d.getMonth(), d.getDate() - ((d.getDay() + 6) % 7)), sun = new Date(mon.getFullYear(), mon.getMonth(), mon.getDate() + 6);
    const wk = [ymd(mon), ymd(sun)];
    const cur = groupRaces((S.entries || []).filter(e => inRange(e, wk) && e.st !== 'DNS'));
    if (!cur.length) return '';
    return `<div class="mz-teamwk"><p class="mz-mylabel">今週レースに出るメンバー <small>${rangeLabel(wk)}</small></p>
      ${cur.map(g => { const i = groupInfo(g); const nm = esc(dispName(g.race));
        return `<div class="row"><span class="dt">${mdw(g.date)}</span><div class="bd"><b>${i && i.url ? `<a href="${esc(i.url)}" target="_blank" rel="noopener">${nm} ↗</a>` : nm}</b>${g.cat ? `<small>${esc(g.cat)}</small>` : ''}
          <div class="who">${g.list.map(e => { const f = fullNameOf(e.email), n = nameOf(e.email);
            return `<button type="button" data-who="${esc(e.email)}">${esc(f)}さん${n && normR(n) !== normR(f) ? `<small>（${esc(n)}）</small>` : ''}</button>`; }).join('')}</div></div></div>`; }).join('')}
      <a href="?open=races" data-board class="more">チームの予定・結果をすべて見る ›</a></div>`;
  }
  function renderMyRaces() {
    const box = $('#mz-my');
    if (!box || !S.me) return;
    if (!N) N = blankEntry();
    EC.target = S.me.email; EC.box = box;
    const t = todayStr(), mine = entriesOf(EC.target);
    const need = mine.filter(e => !e.st && e.date <= t).sort((a, b) => b.date.localeCompare(a.date));
    const up = mine.filter(e => e.date > t).sort((a, b) => a.date.localeCompare(b.date));
    const done = mine.filter(e => e.st && e.date <= t).sort((a, b) => b.date.localeCompare(a.date));
    const doneShown = EC.showAll ? done : done.slice(0, 2).concat(done.slice(2).filter(e => EC.openEntry === e.id || EC.res[e.id]));
    const wn = S.weeklyNotice || {}, TR = 'https://go-trail.net/pages/milers-training';
    const wbar = (wn.inbox || wn.replies) ? `<a class="mz-wkbar" href="${TR}?tab=weekly">${wn.inbox ? `あなたあての週報 ${wn.inbox}件` : ''}${wn.inbox && wn.replies ? '／' : ''}${wn.replies ? '週報にコメントが届きました' : ''} ›</a>` : '';
    const rn = S.reactNotice || {};
    const rbar = (rn.claps || rn.comments) ? `<button type="button" class="mz-wkbar mz-rxbar" data-rxin>あなたの記録に ${rn.claps ? `👏 ${rn.claps}` : ''}${rn.claps && rn.comments ? '・' : ''}${rn.comments ? `💬 ${rn.comments}` : ''} が届きました ›</button>` : '';
    box.innerHTML = `${wbar}${rbar}<section class="mz-my" aria-label="あなたの大会">
      <div class="mz-myhead"><h2>あなたの大会</h2><a href="?open=races" data-board>チームの予定・結果 ›</a></div>
      ${need.length ? `<p class="mz-mylabel need">結果を入れてください（${need.length}件）</p>${need.map(entryCardHTML).join('')}` : ''}
      ${up.length ? `<p class="mz-mylabel">これから出る大会</p>${up.map(entryCardHTML).join('')}` : ''}
      ${EC.formOpen ? `<div class="mz-ecard open"><p class="mz-mylabel" style="margin:0">出る大会を登録</p><div id="n-form">${entryFormHTML()}</div><div class="acts"><button type="button" class="mz-btn ghost sm" data-nclose>やめる</button></div></div>`
        : `<button type="button" class="mz-add" data-nopen>＋ 出る大会を登録</button>`}
      <a class="mz-add mz-wklink" href="${TR}?tab=weekly">✎ 週報を書く（今週・先週）</a>
      ${!need.length && !up.length && !EC.formOpen ? '<p class="hint">出る大会を登録すると、カードに「次戦」が付き、チームの「今週のレース予定」に載ります。大会が終わったら、ここで結果（完走タイム・DNF）を入れます。</p>' : ''}
      ${done.length ? `<p class="mz-mylabel">入れた結果</p>${doneShown.map(entryCardHTML).join('')}${done.length > doneShown.length ? `<button type="button" class="mz-linkbtn" data-showall>入れた結果をすべて見る（${done.length}件）</button>` : ''}` : ''}
      ${teamWeekHTML()}
    </section>`;
    bindEntryTab(box);
  }
  const renderEntryTab = renderMyRaces;
  function rerenderEntryForm() { const f = $('#n-form', EC.box); if (f) f.innerHTML = entryFormHTML(); }
  function bindEntryTab(box) {
    if (box._bound) return;
    box._bound = true;
    box.addEventListener('mousedown', e => { if (e.target.closest('.mz-sugg button')) e.preventDefault(); });
    box.addEventListener('input', e => {
      const t = e.target;
      if (t.dataset.n === 'raceq') {
        N.race = ''; N.cat = '';
        const q = t.value, list = suggestRaces(q), sug = $('#nsugg', box);
        if (!q.trim()) { sug.hidden = true; return; }
        const exact = list.length && (normR(list[0].name) === normR(q) || normR(list[0].short) === normR(q));
        sug.innerHTML = list.map(r => `<button type="button" role="option" data-npick="${esc(r.name)}">${esc(r.short || r.name)}${r.short ? `<span class="sub">${esc(r.name)}</span>` : ''}<small>${r.ov ? '海外' : '国内'}</small></button>`).join('')
          + (exact ? '' : `<button type="button" role="option" data-nreq="${esc(q.trim())}" class="new">見つからないときは → 運営に追加を頼む</button>`);
        sug.hidden = false;
      } else if (t.dataset.n === 'date') N.date = t.value;
      else if (t.dataset.n === 'km') N.km = t.value; // 種目名は残す（例：160K を選んで実際の163kmに直す）
      else if (t.dataset.n === 'ov') N.ov = t.value === '' ? null : t.value === '1';
      else if (t.dataset.r) { const c = t.closest('.mz-ecard'); EC.res[c.dataset.id][t.dataset.r] = t.value; $('.err', c).innerHTML = ''; }
      if (t.dataset.n && $('#n-err', box)) $('#n-err', box).innerHTML = '';
    });
    box.addEventListener('change', e => { if (e.target.dataset.n === 'ov') N.ov = e.target.value === '' ? null : e.target.value === '1'; });
    box.addEventListener('click', async e => {
      const t = e.target;
      const nr = t.closest('[data-nreq]');
      if (nr) { $('#nsugg', box).hidden = true; openRaceRequest(nr.dataset.nreq, name => { const k = findRace(name); N.race = k ? k.name : name; N.ov = k ? k.ov : null; rerenderEntryForm(); }); return; }
      const pk = t.closest('[data-npick]');
      if (pk) {
        const k = findRace(pk.dataset.npick); N.race = k ? k.name : pk.dataset.npick; N.ov = k ? k.ov : null;
        N.cat = ''; N.km = ''; // 大会を選び直したら、前の大会の種目・距離は消す
        if (k && (k.cats || []).length === 1) { N.cat = k.cats[0].label; N.km = k.cats[0].km; }
        rerenderEntryForm(); return;
      }
      const ct = t.closest('[data-ncat]');
      if (ct) { N.cat = ct.dataset.ncat; N.km = ct.dataset.km; rerenderEntryForm(); return; }
      if (t.closest('#n-save')) return saveNewEntry(t.closest('#n-save'));
      if (t.closest('[data-nopen]')) { EC.formOpen = true; renderMyRaces(); const q = $('#nq', box); if (q) q.focus(); return; }
      if (t.closest('[data-nclose]')) { EC.formOpen = false; N = blankEntry(); renderMyRaces(); return; }
      if (t.closest('[data-showall]')) { EC.showAll = true; renderMyRaces(); return; }
      if (t.closest('[data-board]')) { e.preventDefault(); openBoard(); return; }
      const who = t.closest('.mz-teamwk [data-who]');
      if (who) { const c = S.cards.find(x => x.email === who.dataset.who); if (c) openViewer(c.email, true); else openSheet(`${honor(nameOf(who.dataset.who))}の出場予定・結果`, personEntriesHTML(entriesOf(who.dataset.who))); return; }
      const card = t.closest('.mz-ecard');
      const st = t.closest('[data-st]');
      if (st && card) { const R = EC.res[card.dataset.id]; R.st = st.dataset.st; EC.openEntry = card.dataset.id; card.outerHTML = entryCardHTML(S.entries.find(x => x.id === card.dataset.id)); return; }
      if (t.closest('[data-rlatest]')) { const id = t.closest('[data-rlatest]').dataset.rlatest; delete EC.res[id]; EC.openEntry = id; renderEntryTab(); return; }
      if (t.closest('[data-rover]')) {
        // 本人が最新の内容を見たうえで、この画面の入力を採用すると決めたときだけ、草稿の版を最新に合わせる
        const id = t.closest('[data-rover]').dataset.rover, cur = S.entries.find(x => x.id === id), R = EC.res[id];
        if (cur && R) { R.baseRev = cur.rev; R.base = Object.assign({}, cur); }
        EC.openEntry = id; renderEntryTab(); toast('「結果を保存」を押すと、この画面の入力で上書きします'); return;
      }
      if (t.closest('[data-open]')) { const id = t.closest('[data-open]').dataset.open; EC.openEntry = id; delete EC.res[id]; renderEntryTab(); return; }
      if (t.closest('[data-close]') && card) { EC.openEntry = null; delete EC.res[card.dataset.id]; renderEntryTab(); return; }
      if (t.closest('[data-del]')) return deleteEntry(t.closest('[data-del]').dataset.del);
      if (t.closest('[data-rsave]')) return saveResult(t.closest('[data-rsave]'));
    });
  }
  const ENTRY_ERR = { bad_km: '距離は1000kmまでで入れてください', race_catalog_unavailable: '大会の一覧を読み込めませんでした。少し時間をおいて、もう一度お試しください', too_many: '登録できる数の上限に達しました。運営にお知らせください', unknown_race: '大会が一覧にありません。候補から選んでください', bad_date: '日付を入れてください', need_race: '大会を選んでください', need_km: '距離を入れてください', future_result: 'まだ先の大会には結果を入れられません', bad_time: '完走タイムを入れてください（○時間○分）', bad_dnf_km: 'やめた地点を、大会の距離までの数字で入れてください', forbidden: 'この記録は直せません', not_found: '見つかりませんでした。画面を読み込み直してください' };
  async function entryApi(action, payload, btn, errBox) {
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = '保存しています…';
    try {
      const d = await api(action, Object.assign({ target: EC.target }, payload));
      if (!d.ok && d.entries) S.entries = d.entries;
      if (!d.ok && (d.reason === 'conflict' || d.reason === 'not_found')) {
        toast(d.reason === 'conflict' ? '別の画面で先に直されていました。この画面の入力は残しています。どちらにするか選んでください' : 'この予定は別の画面で消されていました');
        renderEntryTab(); afterEntryChange(true); return null;
      }
      if (!d.ok && d.reason === 'request_conflict') {
        toast('この登録は、前に送った内容ですでに保存されています。下の一覧で確かめて、違っていれば直してください');
        N = blankEntry(); EC.openEntry = d.id; renderEntryTab(); afterEntryChange(true); return null;
      }
      if (!d.ok) throw new Error(d.reason);
      S.entries = d.entries || S.entries;
      return d;
    } catch (err) {
      if (err.message !== 'auth') { btn.disabled = false; btn.textContent = label; if (errBox) errBox.innerHTML = `<div class="mz-errors" role="alert">${esc(ENTRY_ERR[err.message] || '保存できませんでした（' + err.message + '）。電波の良いところでもう一度お試しください。')}</div>`; }
      return null;
    }
  }
  async function saveNewEntry(btn) {
    const box = $('#n-err', EC.box);
    const known = N.race ? findRace(N.race) : null;
    const err = !N.race || (DB_READY && !known) ? '大会を候補から選んでください（見つからないときは「運営に追加を頼む」）' : !N.date ? '出場する日を入れてください' : !(Number(N.km) > 0) ? '距離（km）を入れてください' : '';
    if (err) { box.innerHTML = `<div class="mz-errors" role="alert">${esc(err)}</div>`; return; }
    const d = await entryApi('entrySave', { entry: { race: N.race, ov: known ? known.ov : !!N.ov, cat: N.cat, km: Number(N.km), date: N.date, reqKey: N.reqKey } }, btn, box);
    if (!d) return;
    toast(N.date <= todayStr() ? '登録しました。結果も入れてください' : '登録しました');
    EC.openEntry = N.date <= todayStr() ? d.id : null;
    N = blankEntry(); EC.formOpen = false;
    renderEntryTab(); afterEntryChange(false);
  }
  async function saveResult(btn) {
    const card = btn.closest('.mz-ecard'), id = card.dataset.id, e = S.entries.find(x => x.id === id), R = EC.res[id];
    const errBox = $('.err', card);
    const hh = Math.floor(Number(R.h) || 0), mm = Math.floor(Number(R.m) || 0);
    const intOk = v => v === '' || v == null || Number.isInteger(Number(v));
    const msg = !R.st ? '結果を選んでください' : R.st === '完走' && !(intOk(R.h) && intOk(R.m)) ? '時間と分は整数で入れてください（例：18時間5分）' : R.st === '完走' && !(hh > 0 || mm > 0) ? '完走タイムを入れてください（○時間○分）' : R.st === '完走' && !(mm >= 0 && mm < 60 && hh >= 0) ? '分は0〜59で入れてください' : R.st === 'DNF' && !(Number(R.dk) > 0 && Number(R.dk) <= R.base.km) ? `やめた地点を、${R.base.km}kmまでの数字で入れてください` : '';
    if (msg) { errBox.innerHTML = `<div class="mz-errors" role="alert">${esc(msg)}</div>`; return; }
    const b = R.base; // 編集を始めた時点の中身。更新番号も、一覧の最新ではなく草稿のものを送る
    const d = await entryApi('entrySave', { entry: { id, race: b.race, ov: b.ov, cat: b.cat, km: b.km, date: b.date, rev: R.baseRev, st: R.st, h: hh, m: mm, dk: Number(R.dk) || 0, note: R.note || '' } }, btn, errBox);
    if (!d) return;
    // 写真は結果を保存したあとに送る（送れなくても結果は残る）
    if (R.photo) {
      btn.textContent = '写真を送っています…';
      const p = await api('photoUpload', { kind: 'result', id, full: R.photo.full, thumb: R.photo.thumb }).catch(() => ({ ok: false }));
      if (p.ok) { PH[id] = R.photo.thumb; RX[id] = Object.assign(RX[id] || { claps: 0, clapped: false, clappers: [], comments: [] }, { photo: true }); } else toast('結果は保存しました。写真は送れませんでした');
    } else if (R.photoRemove) {
      await api('photoDelete', { kind: 'result', id }).catch(() => {}); delete PH[id]; if (RX[id]) RX[id].photo = false;
    }
    toast(R.st !== '完走' ? '保存しました' : ({ added: '保存しました。戦績にも出ます', pending_profile: '保存しました。カードを作ると戦績にも出ます' }[d.sync] || '保存しました'));
    EC.openEntry = null; delete EC.res[id];
    renderEntryTab(); afterEntryChange(R.st === '完走' || e.st === '完走');
  }
  async function deleteEntry(id) {
    const e = S.entries.find(x => x.id === id);
    if (!e || !confirm(`「${dispName(e.race)}（${mdOf(e.date)}）」を消しますか？${e.st === '完走' ? '\n完走の記録から戦績に入れた分も取り消します。' : ''}`)) return;
    try {
      const d = await api('entryDelete', { target: EC.target, id, rev: e.rev });
      if (!d.ok && d.entries) { S.entries = d.entries; renderEntryTab(); afterEntryChange(true); }
      if (!d.ok && d.reason === 'conflict') return toast('別の画面で先に直されていたので、最新の内容を表示しました。消すときは、もう一度押してください');
      if (!d.ok) throw new Error(d.reason);
      S.entries = d.entries || S.entries;
      toast('消しました');
      renderEntryTab(); afterEntryChange(e.st === '完走');
    } catch (err) { if (err.message !== 'auth') toast('消せませんでした（' + (ENTRY_ERR[err.message] || err.message) + '）'); }
  }
  // 一覧のバッジを直す。完走が変わったときは戦績も変わるので、カードを読み直して編集中の戦績にも入れる
  async function afterEntryChange(racesChanged) {
    if ($('#mz-grid')) renderGrid();
    if (!racesChanged) { if (E) updatePreview(); return; }
    try {
      const d = await api('list');
      if (!d.ok) return;
      S.cards = d.cards; S.entries = d.entries || S.entries;
      S.myProfile = S.cards.find(c => c.email === S.me.email) || null;
      if ($('#mz-grid')) renderGrid();
      renderMyRaces();
      const c = S.cards.find(x => x.email === (E && E.target));
      if (E && c) {
        E.p.races = E.p.races.filter(r => !r.eid).concat((c.races || []).filter(r => r.eid).map(r => Object.assign({}, r)));
        if (!E.p.races.length) E.p.races.push(blankRace());
        if ($('#e-races', E.wrap)) rerenderRaces();
        updatePreview();
      }
    } catch (err) { /* 次に開いたときにそろう */ }
  }

  // ---------- 起動 ----------
  document.addEventListener('keydown', e => {
    const sh = document.querySelector('.mz-sheet');
    if (sh && e.key === 'Escape') { sh.remove(); if (!V && !E) document.body.style.overflow = ''; return; }
    if (E) { if (e.key === 'Escape') closeEditor(); return; }
    if (!V) return;
    if (e.key === 'Escape') closeViewer();
    else if (e.key === 'ArrowRight') V.go(1);
    else if (e.key === 'ArrowLeft') V.go(-1);
  });
  const saved = loadToken();
  if (saved || (DB_NEW && sbLoad())) { S.token = saved; root.innerHTML = '<div class="mz-loading">読み込んでいます…</div>'; start(); }
  else showLogin();
})();
